// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/Lexend.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/icons/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/icons/Delete-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/placeholder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/icons/Vector.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/icons/open.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../src/assets/icons/download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../src/assets/icons/out.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../src/assets/icons/in.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../src/assets/icons/merge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../src/assets/icons/convert.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../src/assets/icons/dots.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../src/assets/icons/save.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../src/assets/icons/secure.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../src/assets/icons/sign.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../src/assets/icons/shapes.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../src/assets/icons/gallery.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../src/assets/icons/stickynote.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../src/assets/icons/ion_shapes-outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../src/assets/icons/Edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../src/assets/icons/Link-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../src/assets/icons/Text-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../src/assets/icons/search.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  @font-face {
    font-family: "Lexend";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
    font-display: swap;
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1100px) {

  .container {
    max-width: 1100px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1441px) {

  .container {
    max-width: 1441px;
  }
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  text-align: center;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
.btn:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.btn:disabled {
  cursor: not-allowed;
}
.btn-sm {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-size: 0.75rem;
  line-height: 1.5;
}
.btn-md {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
@media (min-width: 1024px) {

  .btn-md {
    height: 47px;
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
}
.btn-lg {
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  font-size: 1rem;
  line-height: 1.5;
}
.btn-loading {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.btn-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(94 94 210 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(94 94 210 / 0.3);
}
.btn-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(77 74 184 / var(--tw-bg-opacity));
}
.btn-primary:active {
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 69 / var(--tw-bg-opacity));
}
.btn-primary:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(94 94 210 / var(--tw-bg-opacity));
}
.btn-secondary {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(94 94 210 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(94 94 210 / var(--tw-text-opacity));
}
.btn-secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(77 74 184 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(77 74 184 / var(--tw-text-opacity));
}
.btn-secondary:active {
  --tw-border-opacity: 1;
  border-color: rgb(33 33 69 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(33 33 69 / var(--tw-text-opacity));
}
.btn-secondary:hover:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(94 94 210 / var(--tw-border-opacity));
}
.btn-primary:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(129 129 129 / var(--tw-text-opacity)) !important;
  --tw-shadow: 0px 8px 16px 0px #60617029;
  --tw-shadow-colored: 0px 8px 16px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.btn-primary:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(129 129 129 / var(--tw-text-opacity));
}
.btn-secondary:disabled {
  --tw-border-opacity: 1 !important;
  border-color: rgb(129 129 129 / var(--tw-border-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(129 129 129 / var(--tw-text-opacity)) !important;
}
.btn-primary-outline {
  --tw-border-opacity: 1;
  border-color: rgb(94 94 210 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(94 94 210 / var(--tw-text-opacity));
}
.btn-primary-outline:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(94 94 210 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-primary-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(94 94 210 / var(--tw-text-opacity));
}
.btn-primary-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-primary-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-secondary-outline {
  --tw-border-opacity: 1;
  border-color: rgb(29 28 28 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(29 28 28 / var(--tw-text-opacity));
}
.btn-secondary-outline:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 28 28 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-secondary-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(29 28 28 / var(--tw-text-opacity));
}
.btn-secondary-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-secondary-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-danger {
  --tw-border-opacity: 1;
  border-color: rgb(203 64 4 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(203 64 4 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-danger:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(203 64 4 / var(--tw-bg-opacity));
}
.btn-danger:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-danger:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-danger-outline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 64 4 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(203 64 4 / var(--tw-text-opacity));
}
.btn-danger-outline:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 64 4 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(203 64 4 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-danger-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(203 64 4 / var(--tw-text-opacity));
}
.btn-danger-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-danger-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-success {
  --tw-border-opacity: 1;
  border-color: rgb(0 137 45 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 137 45 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-success:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 137 45 / var(--tw-bg-opacity));
}
.btn-success:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-success:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-success-outline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(0 137 45 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(0 137 45 / var(--tw-text-opacity));
}
.btn-success-outline:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 137 45 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 137 45 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-success-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(0 137 45 / var(--tw-text-opacity));
}
.btn-success-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-success-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-warning {
  --tw-border-opacity: 1;
  border-color: rgb(255 159 67 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 67 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-warning:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 67 / var(--tw-bg-opacity));
}
.btn-warning:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-warning:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-warning-outline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(255 159 67 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 159 67 / var(--tw-text-opacity));
}
.btn-warning-outline:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 159 67 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 67 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-warning-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(255 159 67 / var(--tw-text-opacity));
}
.btn-warning-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-warning-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-white {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.btn-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.btn-white:disabled {
  --tw-text-opacity: 1 !important;
  color: rgb(129 129 129 / var(--tw-text-opacity)) !important;
}
.btn-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.btn-black:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-black:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-black-outline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.btn-black-outline:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.btn-black-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.btn-black-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-black-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-gray {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1;
  color: rgb(29 28 28 / var(--tw-text-opacity));
}
.btn-gray:hover {
  background-color: rgb(235 235 235 / 0.5);
}
.btn-gray:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-gray:disabled:hover {
  border-color: rgb(235 235 235 / 0.5);
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.btn-gray-outline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  background-color: transparent;
  --tw-text-opacity: 1 !important;
  color: rgb(29 28 28 / var(--tw-text-opacity)) !important;
}
.btn-gray-outline:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(110 110 110 / var(--tw-text-opacity));
}
.btn-gray-outline:hover:disabled {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(235 235 235 / var(--tw-text-opacity));
}
.btn-gray-outline:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.btn-gray-outline:disabled:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 209 209 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.rt-form-group .form-label {
  margin-bottom: 0.25rem;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 500;
  text-transform: capitalize;
  --tw-text-opacity: 1;
  color: rgb(29 28 28 / var(--tw-text-opacity));
}
.rt-form-group .form-label span {
  --tw-text-opacity: 1;
  color: rgb(203 64 4 / var(--tw-text-opacity));
}
.rt-form-group .form-select, .rt-form-group .form-input {
  width: 100%;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
  --tw-shadow: 0px 1px 2px 0px #1018280D;
  --tw-shadow-colored: 0px 1px 2px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.rt-form-group .form-select::placeholder, .rt-form-group .form-input::placeholder {
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.rt-form-group .form-select:focus, .rt-form-group .form-input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(94 94 210 / var(--tw-border-opacity));
  --tw-shadow: 0px 1px 0px 0px #E4EAFB, 0px 0px 0px 3px #CED8F7;
  --tw-shadow-colored: 0px 1px 0px 0px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.rt-form-group .form-select.small, .rt-form-group .form-input.small {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.75rem;
  line-height: 1.5;
}
.rt-form-group .form-select.small::placeholder, .rt-form-group .form-input.small::placeholder {
  font-size: 0.75rem;
  line-height: 1.5;
}
.rt-form-group .form-select.medium, .rt-form-group .form-input.medium {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.rt-form-group .form-select.medium::placeholder, .rt-form-group .form-input.medium::placeholder {
  font-size: 0.875rem;
  line-height: 1.5;
}
.rt-form-group .form-select.large, .rt-form-group .form-input.large {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  font-size: 1rem;
  line-height: 1.5;
}
.rt-form-group .form-select.large::placeholder, .rt-form-group .form-input.large::placeholder {
  font-size: 1rem;
  line-height: 1.5;
}
.rt-form-group .form-select:disabled, .rt-form-group .form-input:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}
.rt-form-group .form-select.disabled, .rt-form-group .form-input.disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.8;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.rt-form-group .form-select.disabled:focus, .rt-form-group .form-input.disabled:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.rt-form-group .form-select.form-input-error, .rt-form-group .form-input.form-input-error {
  --tw-border-opacity: 1 !important;
  border-color: rgb(203 64 4 / var(--tw-border-opacity)) !important;
  --tw-shadow: 0px 1px 0px 0px #FFD1D1, 0px 0px 0px 3px #FFD1D1 !important;
  --tw-shadow-colored: 0px 1px 0px 0px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.rt-form-group .form-select.form-input-error:focus, .rt-form-group .form-input.form-input-error:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(203 64 4 / var(--tw-border-opacity)) !important;
  --tw-shadow: 0px 1px 0px 0px #FFD1D1, 0px 0px 0px 3px #FFD1D1 !important;
  --tw-shadow-colored: 0px 1px 0px 0px var(--tw-shadow-color), 0px 0px 0px 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.rt-form-group .form-select .placeholder, .rt-form-group .form-input .placeholder {
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}
.rt-form-group .form-input-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  height: 100%;
  width: 3rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
}
.form-error {
  padding-top: 0.125rem;
  font-size: 0.875rem;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(203 64 4 / var(--tw-text-opacity));
}
.form-check-input.medium {
  height: 0.875rem;
  width: 0.875rem;
  border-radius: 0.25rem;
}
@media (min-width: 768px) {

  .form-check-input.medium {
    height: 1rem;
    width: 1rem;
  }
}
.modal {
  padding: 1.5rem;
}
.modal .modal-heading {
  font-size: 1.25rem;
  line-height: 1.5;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.modal .modal-description {
  font-size: 0.875rem;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity));
}
.modal .modal-footer {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}
.table-container .table {
  width: 100%;
}
.table-container .table thead {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.table-container .table thead th {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1.175rem;
  padding-bottom: 1.175rem;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(83 77 89 / var(--tw-text-opacity));
}
.table-container .table tbody > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-divide-opacity));
}
.table-container .table tbody {
  font-size: 0.875rem;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity));
}
@media (min-width: 768px) {

  .table-container .table tbody > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  }
}
.table-container .table tbody tr td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.5;
  font-weight: 300;
  --tw-text-opacity: 1;
  color: rgb(27 33 40 / var(--tw-text-opacity));
}
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}
.pointer-events-none {
  pointer-events: none !important;
}
.pointer-events-auto {
  pointer-events: auto !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
.static {
  position: static !important;
}
.\\!fixed {
  position: fixed !important;
}
.fixed {
  position: fixed !important;
}
.absolute {
  position: absolute !important;
}
.relative {
  position: relative !important;
}
.inset-0 {
  inset: 0px !important;
}
.inset-x-0 {
  left: 0px !important;
  right: 0px !important;
}
.\\!bottom-px {
  bottom: 1px !important;
}
.\\!right-px {
  right: 1px !important;
}
.\\!top-0 {
  top: 0px !important;
}
.\\!top-px {
  top: 1px !important;
}
.-right-24 {
  right: -6rem !important;
}
.bottom-0 {
  bottom: 0px !important;
}
.bottom-8 {
  bottom: 2rem !important;
}
.left-0 {
  left: 0px !important;
}
.left-1\\/2 {
  left: 50% !important;
}
.left-4 {
  left: 1rem !important;
}
.left-5 {
  left: 1.25rem !important;
}
.right-0 {
  right: 0px !important;
}
.right-4 {
  right: 1rem !important;
}
.right-5 {
  right: 1.25rem !important;
}
.right-8 {
  right: 2rem !important;
}
.right-auto {
  right: auto !important;
}
.top-0 {
  top: 0px !important;
}
.top-2 {
  top: 0.5rem !important;
}
.top-4 {
  top: 1rem !important;
}
.top-5 {
  top: 1.25rem !important;
}
.top-full {
  top: 100% !important;
}
.\\!z-50 {
  z-index: 50 !important;
}
.z-0 {
  z-index: 0 !important;
}
.z-10 {
  z-index: 10 !important;
}
.z-30 {
  z-index: 30 !important;
}
.z-40 {
  z-index: 40 !important;
}
.z-50 {
  z-index: 50 !important;
}
.order-1 {
  order: 1 !important;
}
.col-span-12 {
  grid-column: span 12 / span 12 !important;
}
.col-span-6 {
  grid-column: span 6 / span 6 !important;
}
.m-auto {
  margin: auto !important;
}
.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}
.mx-4 {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}
.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}
.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}
.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}
.-mr-1 {
  margin-right: -0.25rem !important;
}
.mb-1 {
  margin-bottom: 0.25rem !important;
}
.mb-10 {
  margin-bottom: 2.5rem !important;
}
.mb-2 {
  margin-bottom: 0.5rem !important;
}
.mb-3 {
  margin-bottom: 0.75rem !important;
}
.mb-4 {
  margin-bottom: 1rem !important;
}
.mb-5 {
  margin-bottom: 1.25rem !important;
}
.mb-6 {
  margin-bottom: 1.5rem !important;
}
.mb-7 {
  margin-bottom: 1.75rem !important;
}
.mb-8 {
  margin-bottom: 2rem !important;
}
.ml-1 {
  margin-left: 0.25rem !important;
}
.ml-2 {
  margin-left: 0.5rem !important;
}
.ml-4 {
  margin-left: 1rem !important;
}
.ml-auto {
  margin-left: auto !important;
}
.mr-4 {
  margin-right: 1rem !important;
}
.mt-1 {
  margin-top: 0.25rem !important;
}
.mt-10 {
  margin-top: 2.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.mt-3 {
  margin-top: 0.75rem !important;
}
.mt-4 {
  margin-top: 1rem !important;
}
.mt-6 {
  margin-top: 1.5rem !important;
}
.block {
  display: block !important;
}
.inline-block {
  display: inline-block !important;
}
.inline {
  display: inline !important;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex !important;
}
.inline-flex {
  display: inline-flex !important;
}
.table {
  display: table !important;
}
.grid {
  display: grid !important;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none !important;
}
.\\!h-\\[calc\\(100\\%-2px\\)\\] {
  height: calc(100% - 2px) !important;
}
.h-0 {
  height: 0px !important;
}
.h-10 {
  height: 2.5rem !important;
}
.h-12 {
  height: 3rem !important;
}
.h-14 {
  height: 3.5rem !important;
}
.h-24 {
  height: 6rem !important;
}
.h-3 {
  height: 0.75rem !important;
}
.h-3\\.5 {
  height: 0.875rem !important;
}
.h-32 {
  height: 8rem !important;
}
.h-4 {
  height: 1rem !important;
}
.h-4\\.5 {
  height: 1.175rem !important;
}
.h-40 {
  height: 10rem !important;
}
.h-5 {
  height: 1.25rem !important;
}
.h-6 {
  height: 1.5rem !important;
}
.h-6\\.5 {
  height: 1.675rem !important;
}
.h-7 {
  height: 1.75rem !important;
}
.h-80 {
  height: 20rem !important;
}
.h-9 {
  height: 2.25rem !important;
}
.h-\\[1\\.5rem\\] {
  height: 1.5rem !important;
}
.h-\\[1\\.625rem\\] {
  height: 1.625rem !important;
}
.h-\\[1px\\] {
  height: 1px !important;
}
.h-\\[30vh\\] {
  height: 30vh !important;
}
.h-\\[4\\.375rem\\] {
  height: 4.375rem !important;
}
.h-\\[calc\\(100vh-4\\.5rem\\)\\] {
  height: calc(100vh - 4.5rem) !important;
}
.h-auto {
  height: auto !important;
}
.h-full {
  height: 100% !important;
}
.h-max {
  height: max-content !important;
}
.h-screen {
  height: 100vh !important;
}
.min-h-\\[48px\\] {
  min-height: 48px !important;
}
.\\!w-44 {
  width: 11rem !important;
}
.\\!w-\\[fit-content\\] {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.\\!w-full {
  width: 100% !important;
}
.\\!w-max {
  width: max-content !important;
}
.w-0 {
  width: 0px !important;
}
.w-1 {
  width: 0.25rem !important;
}
.w-10 {
  width: 2.5rem !important;
}
.w-12 {
  width: 3rem !important;
}
.w-14 {
  width: 3.5rem !important;
}
.w-24 {
  width: 6rem !important;
}
.w-3 {
  width: 0.75rem !important;
}
.w-3\\.5 {
  width: 0.875rem !important;
}
.w-30 {
  width: 7.5rem !important;
}
.w-32 {
  width: 8rem !important;
}
.w-4 {
  width: 1rem !important;
}
.w-4\\.5 {
  width: 1.175rem !important;
}
.w-44 {
  width: 11rem !important;
}
.w-5 {
  width: 1.25rem !important;
}
.w-56 {
  width: 14rem !important;
}
.w-6 {
  width: 1.5rem !important;
}
.w-6\\.5 {
  width: 1.675rem !important;
}
.w-7 {
  width: 1.75rem !important;
}
.w-9 {
  width: 2.25rem !important;
}
.w-\\[1\\.5rem\\] {
  width: 1.5rem !important;
}
.w-\\[1\\.625rem\\] {
  width: 1.625rem !important;
}
.w-\\[18rem\\] {
  width: 18rem !important;
}
.w-\\[20rem\\] {
  width: 20rem !important;
}
.w-\\[26rem\\] {
  width: 26rem !important;
}
.w-\\[30rem\\] {
  width: 30rem !important;
}
.w-\\[4\\.375rem\\] {
  width: 4.375rem !important;
}
.w-\\[9\\.375rem\\] {
  width: 9.375rem !important;
}
.w-\\[9rem\\] {
  width: 9rem !important;
}
.w-full {
  width: 100% !important;
}
.w-max {
  width: max-content !important;
}
.\\!max-w-6xl {
  max-width: 72rem !important;
}
.max-w-6xl {
  max-width: 72rem !important;
}
.max-w-9xl {
  max-width: 97.5rem !important;
}
.max-w-\\[1920px\\] {
  max-width: 1920px !important;
}
.max-w-\\[40rem\\] {
  max-width: 40rem !important;
}
.max-w-\\[50rem\\] {
  max-width: 50rem !important;
}
.max-w-\\[52\\.625rem\\] {
  max-width: 52.625rem !important;
}
.max-w-full {
  max-width: 100% !important;
}
.max-w-lg {
  max-width: 32rem !important;
}
.max-w-xl {
  max-width: 36rem !important;
}
.flex-1 {
  flex: 1 1 !important;
}
.\\!flex-shrink-0 {
  flex-shrink: 0 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.shrink-0 {
  flex-shrink: 0 !important;
}
.origin-top-right {
  transform-origin: top right !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-\\[200\\%\\] {
  --tw-translate-x: -200% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-0 {
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-full {
  --tw-translate-x: 100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-rotate-180 {
  --tw-rotate: -180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-rotate-90 {
  --tw-rotate: -90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-0 {
  --tw-rotate: 0deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-180 {
  --tw-rotate: 180deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90 {
  --tw-rotate: 90deg !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-100 {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-95 {
  --tw-scale-x: .95 !important;
  --tw-scale-y: .95 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite !important;
}
.cursor-pointer {
  cursor: pointer !important;
}
.resize {
  resize: both !important;
}
.list-inside {
  list-style-position: inside !important;
}
.list-disc {
  list-style-type: disc !important;
}
.appearance-none {
  appearance: none !important;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.\\!flex-row-reverse {
  flex-direction: row-reverse !important;
}
.flex-col {
  flex-direction: column !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.items-center {
  align-items: center !important;
}
.justify-end {
  justify-content: flex-end !important;
}
.justify-center {
  justify-content: center !important;
}
.\\!justify-between {
  justify-content: space-between !important;
}
.justify-between {
  justify-content: space-between !important;
}
.gap-1 {
  gap: 0.25rem !important;
}
.gap-1\\.5 {
  gap: 0.375rem !important;
}
.gap-10 {
  gap: 2.5rem !important;
}
.gap-2 {
  gap: 0.5rem !important;
}
.gap-2\\.5 {
  gap: 0.625rem !important;
}
.gap-3 {
  gap: 0.75rem !important;
}
.gap-4 {
  gap: 1rem !important;
}
.gap-5 {
  gap: 1.25rem !important;
}
.gap-6 {
  gap: 1.5rem !important;
}
.gap-8 {
  gap: 2rem !important;
}
.gap-\\[3\\.5rem\\] {
  gap: 3.5rem !important;
}
.gap-x-3 {
  column-gap: 0.75rem !important;
}
.gap-y-10 {
  row-gap: 2.5rem !important;
}
.gap-y-2 {
  row-gap: 0.5rem !important;
}
.gap-y-4 {
  row-gap: 1rem !important;
}
.gap-y-8 {
  row-gap: 2rem !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(1px * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(1px * var(--tw-space-y-reverse)) !important;
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0 !important;
  border-right-width: calc(1px * var(--tw-divide-x-reverse)) !important;
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse))) !important;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0 !important;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse))) !important;
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse)) !important;
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1 !important;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity)) !important;
}
.divide-secondary-30 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1 !important;
  border-color: rgb(239 239 239 / var(--tw-divide-opacity)) !important;
}
.overflow-auto {
  overflow: auto !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.overflow-y-auto {
  overflow-y: auto !important;
}
.whitespace-nowrap {
  white-space: nowrap !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-2xl {
  border-radius: 1rem !important;
}
.rounded-3xl {
  border-radius: 1.5rem !important;
}
.rounded-\\[10px\\] {
  border-radius: 10px !important;
}
.rounded-\\[14px\\] {
  border-radius: 14px !important;
}
.rounded-full {
  border-radius: 9999px !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-md {
  border-radius: 0.375rem !important;
}
.rounded-xl {
  border-radius: 0.75rem !important;
}
.border {
  border-width: 1px !important;
}
.border-8 {
  border-width: 8px !important;
}
.border-b {
  border-bottom-width: 1px !important;
}
.border-t-2 {
  border-top-width: 2px !important;
}
.border-dashed {
  border-style: dashed !important;
}
.border-\\[\\#D3D3D3\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(211 211 211 / var(--tw-border-opacity)) !important;
}
.border-google {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.border-primary {
  --tw-border-opacity: 1 !important;
  border-color: rgb(94 94 210 / var(--tw-border-opacity)) !important;
}
.border-secondary-30 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 239 239 / var(--tw-border-opacity)) !important;
}
.border-secondary-650 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(119 119 119 / var(--tw-border-opacity)) !important;
}
.border-secondary-80 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(224 224 224 / var(--tw-border-opacity)) !important;
}
.border-warning-200\\/50 {
  border-color: rgb(255 207 30 / 0.5) !important;
}
.border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.border-t-primary-600 {
  --tw-border-opacity: 1 !important;
  border-top-color: rgb(110 110 214 / var(--tw-border-opacity)) !important;
}
.bg-\\[\\#F3F3FF\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 243 255 / var(--tw-bg-opacity)) !important;
}
.bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.bg-danger-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 236 230 / var(--tw-bg-opacity)) !important;
}
.bg-google {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(94 94 210 / var(--tw-bg-opacity)) !important;
}
.bg-primary-400 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(246 246 253 / var(--tw-bg-opacity)) !important;
}
.bg-primary-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(142 142 224 / var(--tw-bg-opacity)) !important;
}
.bg-secondary-10 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity)) !important;
}
.bg-secondary-30 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity)) !important;
}
.bg-secondary-80 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity)) !important;
}
.bg-success-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(232 253 241 / var(--tw-bg-opacity)) !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.bg-warning-100\\/10 {
  background-color: rgb(226 181 62 / 0.1) !important;
}
.bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1) !important;
}
.bg-opacity-25 {
  --tw-bg-opacity: 0.25 !important;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75 !important;
}
.bg-gradient-pro {
  background-image: linear-gradient(92.57deg, #F2BF4B 0.62%, #CD7C2E 99.47%) !important;
}
.bg-gradient-side-panel {
  background-image: linear-gradient(175.26deg, #30306C 0.48%, #5E5ED2 96.17%) !important;
}
.object-contain {
  object-fit: contain !important;
}
.object-cover {
  object-fit: cover !important;
}
.p-0 {
  padding: 0px !important;
}
.p-0\\.5 {
  padding: 0.125rem !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.p-1\\.5 {
  padding: 0.375rem !important;
}
.p-10 {
  padding: 2.5rem !important;
}
.p-3 {
  padding: 0.75rem !important;
}
.p-4 {
  padding: 1rem !important;
}
.p-5 {
  padding: 1.25rem !important;
}
.p-8 {
  padding: 2rem !important;
}
.\\!px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.px-8 {
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}
.px-\\[5\\.875rem\\] {
  padding-left: 5.875rem !important;
  padding-right: 5.875rem !important;
}
.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.py-0\\.5 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}
.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}
.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}
.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.py-3\\.5 {
  padding-top: 0.875rem !important;
  padding-bottom: 0.875rem !important;
}
.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}
.py-\\[1\\.125rem\\] {
  padding-top: 1.125rem !important;
  padding-bottom: 1.125rem !important;
}
.pb-16 {
  padding-bottom: 4rem !important;
}
.pb-20 {
  padding-bottom: 5rem !important;
}
.pb-26 {
  padding-bottom: 6.5rem !important;
}
.pb-4 {
  padding-bottom: 1rem !important;
}
.pb-8 {
  padding-bottom: 2rem !important;
}
.pl-10 {
  padding-left: 2.5rem !important;
}
.pl-3 {
  padding-left: 0.75rem !important;
}
.pl-4 {
  padding-left: 1rem !important;
}
.pr-10 {
  padding-right: 2.5rem !important;
}
.pr-12 {
  padding-right: 3rem !important;
}
.pr-4 {
  padding-right: 1rem !important;
}
.pr-5 {
  padding-right: 1.25rem !important;
}
.pt-2 {
  padding-top: 0.5rem !important;
}
.pt-4 {
  padding-top: 1rem !important;
}
.pt-8 {
  padding-top: 2rem !important;
}
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.\\!text-right {
  text-align: right !important;
}
.text-right {
  text-align: right !important;
}
.\\!text-base {
  font-size: 1rem !important;
  line-height: 1.5 !important;
}
.\\!text-xl {
  font-size: 1.25rem !important;
  line-height: 1.5 !important;
}
.text-2xl {
  font-size: 1.5rem !important;
  line-height: 1.5 !important;
}
.text-3xl {
  font-size: 1.875rem !important;
  line-height: 1.5 !important;
}
.text-4xl {
  font-size: 2rem !important;
  line-height: 1.5 !important;
}
.text-5xl {
  font-size: 3rem !important;
  line-height: 1.5 !important;
}
.text-6xl {
  font-size: 3.75rem !important;
  line-height: 1.5 !important;
}
.text-\\[1\\.625rem\\] {
  font-size: 1.625rem !important;
}
.text-\\[2\\.375rem\\] {
  font-size: 2.375rem !important;
}
.text-base {
  font-size: 1rem !important;
  line-height: 1.5 !important;
}
.text-lg {
  font-size: 1.125rem !important;
  line-height: 1.5 !important;
}
.text-sm {
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
}
.text-xl {
  font-size: 1.25rem !important;
  line-height: 1.5 !important;
}
.text-xs {
  font-size: 0.75rem !important;
  line-height: 1.5 !important;
}
.\\!font-medium {
  font-weight: 500 !important;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700 !important;
}
.font-light {
  font-weight: 300 !important;
}
.font-medium {
  font-weight: 500 !important;
}
.font-normal {
  font-weight: 400 !important;
}
.font-semibold {
  font-weight: 600 !important;
}
.uppercase {
  text-transform: uppercase !important;
}
.capitalize {
  text-transform: capitalize !important;
}
.leading-4 {
  line-height: 1rem !important;
}
.leading-5 {
  line-height: 1.25rem !important;
}
.leading-6 {
  line-height: 1.5rem !important;
}
.tracking-wide {
  letter-spacing: 0.025em !important;
}
.\\!text-secondary-650 {
  --tw-text-opacity: 1 !important;
  color: rgb(119 119 119 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#2E2E2E\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(46 46 46 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#777777\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(119 119 119 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#8A8A8A\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(138 138 138 / var(--tw-text-opacity)) !important;
}
.text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.text-danger {
  --tw-text-opacity: 1 !important;
  color: rgb(203 64 4 / var(--tw-text-opacity)) !important;
}
.text-danger-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(174 51 6 / var(--tw-text-opacity)) !important;
}
.text-gray-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.text-gray-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity)) !important;
}
.text-grey-200 {
  --tw-text-opacity: 1 !important;
  color: rgb(246 246 246 / var(--tw-text-opacity)) !important;
}
.text-grey-300 {
  --tw-text-opacity: 1 !important;
  color: rgb(51 51 51 / var(--tw-text-opacity)) !important;
}
.text-grey-650 {
  --tw-text-opacity: 1 !important;
  color: rgb(109 109 109 / var(--tw-text-opacity)) !important;
}
.text-grey-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(136 136 136 / var(--tw-text-opacity)) !important;
}
.text-grey-900 {
  --tw-text-opacity: 1 !important;
  color: rgb(17 24 39 / var(--tw-text-opacity)) !important;
}
.text-primary {
  --tw-text-opacity: 1 !important;
  color: rgb(94 94 210 / var(--tw-text-opacity)) !important;
}
.text-red-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.text-red-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(185 28 28 / var(--tw-text-opacity)) !important;
}
.text-secondary {
  --tw-text-opacity: 1 !important;
  color: rgb(29 28 28 / var(--tw-text-opacity)) !important;
}
.text-secondary-1000 {
  --tw-text-opacity: 1 !important;
  color: rgb(46 46 46 / var(--tw-text-opacity)) !important;
}
.text-secondary-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(156 155 155 / var(--tw-text-opacity)) !important;
}
.text-secondary-450 {
  --tw-text-opacity: 1 !important;
  color: rgb(151 151 151 / var(--tw-text-opacity)) !important;
}
.text-secondary-50 {
  --tw-text-opacity: 1 !important;
  color: rgb(241 241 241 / var(--tw-text-opacity)) !important;
}
.text-secondary-500 {
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}
.text-secondary-550 {
  --tw-text-opacity: 1 !important;
  color: rgb(138 137 137 / var(--tw-text-opacity)) !important;
}
.text-secondary-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(129 129 129 / var(--tw-text-opacity)) !important;
}
.text-secondary-650 {
  --tw-text-opacity: 1 !important;
  color: rgb(119 119 119 / var(--tw-text-opacity)) !important;
}
.text-secondary-80 {
  --tw-text-opacity: 1 !important;
  color: rgb(224 224 224 / var(--tw-text-opacity)) !important;
}
.text-sky-100 {
  --tw-text-opacity: 1 !important;
  color: rgb(224 242 254 / var(--tw-text-opacity)) !important;
}
.text-success-1000 {
  --tw-text-opacity: 1 !important;
  color: rgb(31 97 66 / var(--tw-text-opacity)) !important;
}
.text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.underline {
  text-decoration-line: underline !important;
}
.\\!opacity-60 {
  opacity: 0.6 !important;
}
.opacity-0 {
  opacity: 0 !important;
}
.opacity-100 {
  opacity: 1 !important;
}
.shadow-13xl {
  --tw-shadow: 0px 0px 3px 0px #00000015,0px 2px 3px 0px #0000002B !important;
  --tw-shadow-colored: 0px 0px 3px 0px var(--tw-shadow-color), 0px 2px 3px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-14xl {
  --tw-shadow: 0px 4px 20px 0px #236ABD1F !important;
  --tw-shadow-colored: 0px 4px 20px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-9xl {
  --tw-shadow: 0px 25px 26px 0px #0000001A !important;
  --tw-shadow-colored: 0px 25px 26px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-header {
  --tw-shadow: 0px 12px 24px 0px #0000000A !important;
  --tw-shadow-colored: 0px 12px 24px 0px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-black {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity)) !important;
}
.ring-white {
  --tw-ring-opacity: 1 !important;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity)) !important;
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05 !important;
}
.ring-opacity-60 {
  --tw-ring-opacity: 0.6 !important;
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px !important;
}
.drop-shadow-7xl {
  --tw-drop-shadow: drop-shadow(0px 24px 40px rgba(0, 0, 0, 0.08)) !important;
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px) !important;
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia) !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-all {
  transition-property: all !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition-opacity {
  transition-property: opacity !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.duration-100 {
  transition-duration: 100ms !important;
}
.duration-300 {
  transition-duration: 300ms !important;
}
.duration-500 {
  transition-duration: 500ms !important;
}
.duration-75 {
  transition-duration: 75ms !important;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}
html, body, *{
  font-family: "Lexend", sans-serif !important;
}

body,
html {
  margin: 0;
  padding: 0;
}

code {
  font-family: "Lexend", source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

body {
  min-width: 320px;
  margin: 0;
  padding: 0;
  font-family: "Lexend", sans-serif;
}

button.outline {
  border-color: #5e5ed2;
  color: #5e5ed2;
}

:root {
  /* Step 0: 28.00px → 48.00px */
  --h1: clamp(1.75rem, calc(0.86rem + 2.38vw), 3rem);
  --h1-custom: clamp(2rem, calc(0.86rem + 2.38vw), 3rem);
  /* Step 0: 24.00px → 40.00px */
  --h2: clamp(1.5rem, calc(1.16rem + 1.49vw), 2.5rem);
  /* Step 0: 20.00px → 32.00px */
  --h3: clamp(1.25rem, calc(0.4364rem + 1.6949vw), 1.75rem);
  /* Step 0: 18.00px → 28.00px */
  --h4: clamp(1.125rem, calc(0.8625rem + 1.1475vw), 1.5rem);
  /* Step 0: 16.00px → 20.00px */
  --h5: clamp(1rem, calc(0.4364rem + 1.6949vw), 1.25rem);
  /* Step 0: 14.00px → 16.00px */
  --h6: clamp(0.875rem, calc(0.4364rem + 1.6949vw), 1rem);
}

.h1-custom {
  font-size: var(--h1-custom);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h1,
h1 {
  font-size: var(--h1);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h2,
h2 {
  font-size: var(--h2);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h3,
h3 {
  font-size: var(--h3);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h4,
h4 {
  font-size: var(--h4);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h5,
h5 {
  font-size: var(--h5);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}
.h6,
h6 {
  font-size: var(--h6);
  line-height: 1.25;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity));
}

.container-lg {
  margin-left: auto;
  margin-right: auto;
  max-width: 1920px;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 768px) {

  .container-lg {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

@media (min-width: 1024px) {

  .container-lg {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1280px) {

  .container-lg {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 88rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 768px) {

  .container {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .container {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1280px) {

  .container {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
p {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 300;
  --tw-text-opacity: 1;
  color: rgb(92 92 92 / var(--tw-text-opacity));
}
@media (min-width: 768px) {

  p {
    font-size: 1.125rem;
    line-height: 1.5;
  }
}
a {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(94 94 210 / var(--tw-text-opacity));
}
@media (min-width: 768px) {

  a {
    font-size: 1.125rem;
    line-height: 1.5;
  }
}

@media (min-width: 640px) {
  .sm\\:grid-rows-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr)) !important;
  }
}

.btnClose > svg {
  width: 2.2em;
  height: 2.2em;
}
.btnClose:hover > svg > path {
  stroke: #5e5ed2;
}

button[name="hand-tool"] {
  justify-content: center;
}

.fx-ribbon-item[name="find-replace"] {
  min-width: 145px !important;
}

div[name="find-replace-dialog"] .fv__ui-dropdown-toggler {
  padding: 0 !important;
}

.fx-ribbon-item[name="edit-text"] .fx-ribbon-item-icon,
.fx-ribbon-item[name="find-replace"] .fx-ribbon-item-icon {
  position: absolute;
  width: 100%;
  height: 100%;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.OTPInputs input {
  margin: 10px;
  height: 45px;
  width: 65px;
  border: none;
  border-radius: 5px;
  text-align: center;
  font-family: arimo;
  font-size: 1.2rem;
  background: #eef2f3;
}

.OTPInputs .container {
  display: flex;
  flex-flow: column;
  height: 100%;
  align-items: space-around;
  justify-content: center;
}

.OTPInputs .userInput {
  display: flex;
  justify-content: center;
}

.dropDown svg {
  opacity: 0;
  visibility: hidden;
}
.dropDown:after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 100% 100%;
  width: 15px;
  height: 8px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  margin-top: 2px;
}

.pdfMenu {
  padding: 0 !important;
  border: solid #e9e9e9;
  border-width: 1px 0 1px 0;
  overflow: hidden;
}

.fx-ribbon-item {
  margin: 0 !important;
}

.fx-ribbon-item:hover,
.fv__ui-button:not(.disabled):hover,
.fv__ui-toolbar .fv__ui-dropdown-toggler.active,
.fv__ui-toolbar .fv__ui-dropdown-toggler:hover,
a.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,
.fx-ribbon-item-active,
a.more-dropdown.active,
a.more-dropdown:hover,
.fv__ui-button.active,
.fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,
.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,
.fv__ui-toolbar
  .fv__ui-dropdown.active
  > .fv__ui-dropdown-toggler
  .fv__ui-dropdown-caret {
  background-color: #bdbdfd !important;
}

.fv__ui-toolbar .fv__ui-dropdown.selected .fv__ui-dropdown-toggler,
.fv__ui-toolbar
  .fv__ui-dropdown.selected
  .fv__ui-dropdown-toggler
  .fv__ui-dropdown-caret,
.image-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,
.fv__ui-dropdown-list.fv__ui-sign-dropdown-list
  .fv__ui-sign-item:not(.disabled):focus,
.fv__ui-dropdown-list.fv__ui-sign-dropdown-list
  .fv__ui-sign-item:not(.disabled):hover,
li[name="create-signature-btn"]:hover {
  background-color: transparent !important;
}

button#component-lfw7vsaz > span {
  color: #fff !important;
}

.fx-ribbon-item-icon {
  overflow: visible !important;
}

.online-checkbox-inner {
  width: 24px !important;
  height: 24px !important;
  border-radius: 4px !important;
  background-color: #5e5ed2 !important;
}
.online-checkbox-inner:after {
  border-bottom: 2px solid #ffff !important;
  border-left: 0;
  border-left-color: #ffff !important;
  border-right: 2px solid #ffff !important;
  border-top: 0;
  border-top-color: #ffff !important;
  left: 31% !important;
}

a.image-dropdown .fv__ui-dropdown-caret {
  position: absolute !important;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
}

a.image-dropdown ul.fv__ui-dropdown-list,
.edit-object-ribbon-dropdown ul.fv__ui-dropdown-list,
a[name="password-protect-controllers"] ul.fv__ui-dropdown-list,
a[name="signature-dropdown"] ul.fv__ui-dropdown-list,
a[name="create-shape-dropdown"] ul.fv__ui-dropdown-list,
a[name="freetext-textbox"] ul.fv__ui-dropdown-list,
a[name="dropdown-zoom"] .fv__ui-dropdown-list {
  padding: 12px 12px !important;
  min-width: auto !important;
  border-radius: 10px;
}

button[name="download-file-button"],
button.open-file,
a[name="create-shape-dropdown"],
a.image-dropdown,
a[name="freetext-textbox"] {
  min-width: 145px !important;
}

a.more-dropdown,
a.fv__ui-sign-dropdown {
  min-width: 125px !important;
}

a[name="dropdown-zoom"],
a[name="password-protect-controllers"] {
  display: block !important;
  position: static !important;
  width: 100% !important;
  height: auto !important;
}

a[name="create-shape-dropdown"],
a[name="freetext-textbox"] {
  display: block !important;
  position: relative !important;
  width: 100% !important;
  height: auto !important;
  text-align: left;
}

a.more-dropdown .fv__ui-dropdown-list .fv__ui-dropdown-toggler {
  position: relative !important;
  padding-left: 7px !important;
  padding-right: 7px !important;
  justify-content: flex-start !important;
}

a.more-dropdown > .fv__ui-dropdown-list > *,
.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > * {
  border-bottom: 1px solid #ccc !important;
  border-radius: 0;
}
.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > * {
  height: 56px;
}
.fv__ui-dropdown-list > a:last-child,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(4) {
  border-bottom: 0 !important;
}

a[name="freetext-textbox"] ul.fv__ui-dropdown-list {
  padding-top: 70px;
  padding-bottom: 30px;
}
a[name="freetext-textbox"] ul.fv__ui-dropdown-list .fx-ribbon-item {
  display: inline-block;
  vertical-align: middle;
}

a[name="freetext-textbox"] ul.fv__ui-dropdown-list:before {
  position: absolute;
  content: "Fill non interactive forms";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.25;
  color: #2e2e2e;
  top: -1px;
  left: 0;
  right: 0;
  height: 44px;
  background-color: #bdbdfd;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

a[name="freetext-textbox"] ul.fv__ui-dropdown-list .fx-ribbon-item {
  margin: 0px !important;
  border-radius: 0.5rem !important;
  padding: 0.5rem !important;
}
a[name="freetext-textbox"] ul.fv__ui-dropdown-list .fx-ribbon-item:first-child {
  margin-top: 2.5rem !important;
}
a[name="freetext-textbox"]
  ul.fv__ui-dropdown-list
  .fx-ribbon-item
  .fx-ribbon-item-text {
  padding-right: 0px !important;
  padding-left: 0.75rem;
}
a[name="freetext-textbox"] ul.fv__ui-dropdown-list {
  width: 250px;
}
a[name="password-protect-controllers"]
  ul.fv__ui-dropdown-list
  .fv__ui-button
  .fv__ui-dropdown-item-text {
  margin: 0px !important;
  padding: 0px !important;
}
a.image-dropdown ul.fv__ui-dropdown-list {
  min-height: 90px;
}
a[name="signature-dropdown"] ul.fv__ui-dropdown-list {
  min-height: 10px;
}
.fv__ui-sign-list-icon-item {
  padding: 5px 0;
  border-bottom: 1px solid #ececec;
}
.fv__ui-sign-list {
  margin-bottom: 10px;
}
a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button {
  position: static;
}
a[name="signature-dropdown"]
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button:before,
a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {
  position: absolute;
  background-color: #5e5ed2;
  border-radius: 10px;
  width: 182px;
  height: 52px;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.25;
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
a[name="signature-dropdown"]
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button:before {
  content: "+ Add Signature";
  bottom: auto;
  top: 50%;
  transform: translate(-50%, -50%);
}
a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {
  content: "Upload Image";
}
/* a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:after {
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
  width: 100%;
  height: 1px;
  transform: translateX(-50%);
  background-color: #ececec;
} */

div[name="create-signature"] .fv__ui-layer-header {
  padding: 24px 20px;
  text-align: center;
  background: #5e5ed2;
  margin: -23px -22px 0;
  border-radius: 7px 7px 0 0;
}
div[name="create-signature"] .fv__ui-layer-header .fv__ui-layer-header-title {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.25;
  text-align: center;
  color: #fff;
}
div[name="create-signature"] .fv__ui-layer-header .fv__ui-layer-header-button {
  position: relative;
}
div[name="create-signature"]
  .fv__ui-layer-header
  .fv__ui-layer-header-button:before {
  position: absolute;
  background-color: #fff;
  width: 20px;
  height: 2px;
  content: "";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
}
div[name="create-signature"]
  .fv__ui-layer-header
  .fv__ui-layer-header-button:after {
  position: absolute;
  background-color: #fff;
  width: 20px;
  height: 2px;
  content: "";
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}

.fv__ui-sign-dialog-tab-panel
  .fv__ui-sign-dialog-panel[name="sign-dialog-panel-type"]
  .type-body
  .customInput
  .addList,
.fv__ui-layer .footer .fv__ui-dialog-ok-button,
.fv__ui-layer .footer .fv__ui-dialog-cancel-button,
.fv__password-protect-popup
  .document-permission-wrapper-inner
  .permission-edit-btn {
  border-color: #5e5ed2 !important;
  background-color: #5e5ed2 !important;
  border-radius: 10px !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px !important;
  line-height: 1.25 !important;
  text-align: center;
  color: #fff !important;
  align-items: center;
  justify-content: center;
  min-height: 52px !important;
  height: auto !important;
}

div.password-protect-footer
  > .fv__ui-layer
  .footer
  .fv__ui-dialog-ok-button:not(.disabled):hover {
  color: #fff !important;
  opacity: 0.3 !important;
}

div[name="create-signature"] .fv__ui-layer-header .fv__ui-layer-header-inner {
  margin-bottom: 0;
}

div.fv__ui-sign-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

a.image-dropdown
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__ui-button-text,
a[name="signature-dropdown"]
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__ui-dropdown-item-text {
  position: static;
  width: 0;
  height: 0;
}

a.image-dropdown .fv__ui-button.active {
  background: none !important;
}

/* a.image-dropdown
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__ui-button-text::after {
  position: absolute;
  content: "";
  background-image: url(../src/assets/icons/Delete-icon.svg);
  width: 30px;
  height: 30px;
  right: 20px;
  top: 24%;
  transform: translateY(-50%);
} */
.fv__icon-toolbar-delete-sign {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  position: absolute;
  right: 20px;
}

a.image-dropdown
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__icon-toolbar-image,
a[name="signature-dropdown"]
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__icon-toolbar-add-sign {
  position: static;
  background-image: none;
}

a.image-dropdown
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button
  .fv__icon-toolbar-image:before {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 136px;
  height: 55px;
  left: 25px;
  top: 24%;
  transform: translateY(-50%);
}

a[name="create-shape-dropdown"] ul.fv__ui-dropdown-list .fx-icon-sm {
  width: 1.5rem;
  height: 1.5rem;
}
a[name="create-shape-dropdown"]
  ul.fv__ui-dropdown-list
  .fv__ui-dropdown-item-text {
  margin-left: 1rem;
}

a[name="create-shape-dropdown"]
  ul.fv__ui-dropdown-list
  > li.fv__ui-dropdown-button {
  height: 37px;
}

a[name="create-shape-dropdown"]
  ul.fv__ui-dropdown-list
  > li.fv__ui-dropdown-button,
a[name="password-protect-controllers"]
  ul.fv__ui-dropdown-list
  > li.fv__ui-dropdown-button
  span,
a[name="dropdown-zoom"] .fv__ui-dropdown-item-text {
  font-size: 16px !important;
  line-height: 1.25 !important;
}

.fx-ribbon-item.active,
.fx-ribbon-item.selected,
.fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,
.fv__ui-toolbar .fv__ui-dropdown.active,
.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,
.fx-ribbon-item:hover,
.fv__ui-toolbar .fx-ribbon-item.fx-ribbon-item-active:focus,
.fv__ui-toolbar .fv__ui-dropdown-toggler.active,
.fv__ui-toolbar .fv__ui-dropdown-toggler:hover,
.fv__ui-dropdown-caret:focus,
.fv__ui-dropdown-icon:focus,
.fv__ui-dropdown-list
  > li.fv__ui-dropdown-button:not(.active):not(:hover):not(.disabled):focus,
.fv__ui-dropdown-list
  > li.fv__ui-dropdown-container-item:not(.active):not(:hover):not(
    .disabled
  ):focus,
.fv__ui-dropdown-toggler:focus,
.fv__ui-editable-dropdown .fv__ui-dropdown-caret:focus,
.fv__ui-layer:not(.float-bar) .fv__ui-dropdown.active .fv__ui-dropdown-toggler,
.fv__ui-layer:not(.float-bar)
  .fv__ui-dropdown.selected
  .fv__ui-dropdown-toggler,
.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,
.fv__ui-toolbar .fv__ui-dropdown.selected .fv__ui-dropdown-toggler,
.fv__ui-toolbar
  .fv__ui-dropdown.selected
  .fv__ui-dropdown-toggler
  .fv__ui-dropdown-caret,
.fv__ui-toolbar
  .fv__ui-dropdown.active
  > .fv__ui-dropdown-toggler
  .fv__ui-dropdown-caret,
.fv__ui-dropdown-list.fv__ui-sign-dropdown-list
  .fv__ui-sign-item:not(.disabled):hover,
.fv__ui-dropdown-list.fv__ui-sign-dropdown-list
  .fv__ui-sign-item:not(.disabled):focus,
/* .fv__ui-button:not(.disabled):not(.active):focus, */
button[name="create-link"]:hover,
button[name="download-file-button"]:hover,
button.open-file:hover {
  border-radius: 0 !important;
  outline: none !important;
}

a.image-dropdown .fv__ui-dropdown-icon,
.fv__ui-grouplist-item:after,
.fv__ui-grouplist-item[name="edit-tab-group-hand"],
.fv__ui-grouplist-item[name="edit-tab-group-font"],
.fx-ribbon-item[name="fv--addon-add-text-button"],
.fx-ribbon-item[name="doc-attachment-button"],
.fx-ribbon-item[name="create-image"],
.fx-ribbon-item[name="multi-media-btn"],
.fx-ribbon-item[name="edit-text"] .fx-ribbon-item-icon .fx-icon,
.fx-ribbon-item[name="edit-text"] .fx-icon-ribbon_home_editobject-32,
.fx-ribbon-item[name="edit-text"] .fx-ribbon-item-text,
.fx-ribbon-item[name="create-link"] .fx-ribbon-item-icon,
.fx-ribbon-item[name="create-link"] .fx-ribbon-item-text,
.fx-ribbon-item[name="image-tool"] .fx-ribbon-item-icon,
.fx-ribbon-item[name="image-tool"] .fx-ribbon-item-text,
.fx-ribbon-item[name="create-shapeObject-dropdown"] .fx-ribbon-item-icon,
.fx-ribbon-item[name="create-shapeObject-dropdown"] .fx-ribbon-item-text,
a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-icon,
a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler .fv__ui-dropdown-toggler-text,
a[name="open-file-button-list"] button.fv__icon-toolbar-open,
a[name="freetext-textbox"] .fv__icon-toolbar-textbox,
.fx-ribbon-item[name="find-replace"] .fx-ribbon-item-text,
.fx-ribbon-item[name="find-replace"] .fx-ribbon-item-icon .fx-icon,
.edit-object-ribbon-dropdown .fx-ribbon-item-text {
  display: none !important;
}

a[name="freetext-textbox"],
.fx-ribbon-item[name="edit-text"],
button[name="create-link"],
.fx-ribbon-item[name="image-tool"],
.fx-ribbon-item[name="create-shapeObject-dropdown"],
.pdfMenu > :nth-child(n) {
  background-image: none;
  position: relative;
  min-width: 105px;
  width: 75px !important;
  height: 48px !important;
}
.fx-ribbon-item[name="edit-text"],
.fx-ribbon-item[name="edit-object-ribbon-dropdown"] {
  min-width: 145px;
}
.fx-ribbon-item[name="fv--plugin-PageEditor-add-text"] {
  min-width: 125px;
}
.fx-ribbon-item[name="fv--plugin-PageEditor-add-image"] {
  min-width: 140px;
}
button[name="create-link"] i.fv__ui-button-icon {
  position: relative;
  display: block;
}

a[name="freetext-textbox"] button.fv__ui-dropdown-caret,
a.image-dropdown button.fv__ui-dropdown-caret,
a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-caret,
a[name="create-shape-dropdown"]
  a.fv__ui-dropdown-toggler
  .fv__ui-dropdown-caret,
a[name="create-shape-dropdown"] .fv__ui-dropdown-icon,
a[name="open-file-button-list"] .fv__icon-toolbar-caret,
button.open-file .fv__ui-button-text,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler .fv__icon-toolbar-zoom-out,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler .fv__icon-toolbar-zoom-in,
a[name="password-protect-controllers"] .fv__icon-toolbar-caret,
a[name="password-protect-controllers"] .fv__ui-dropdown-icon,
button[name="download-file-button"] .fv__icon-toolbar-download,
a.more-dropdown .fv__ui-dropdown-caret {
  flex-shrink: 0;
  background-image: none !important;
  position: static !important;
}

a.more-dropdown .fv__ui-dropdown-caret {
  left: 0;
  right: 0;
  width: 100% !important;
  position: absolute !important;
  top: 0;
  bottom: 0;
}

a[name="password-protect-controllers"] .fv__ui-dropdown-caret {
  z-index: 1;
}

a[name="freetext-textbox"] button.fv__ui-dropdown-caret:after,
a.image-dropdown button.fv__ui-dropdown-caret:after,
a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-caret:after,
a[name="create-shape-dropdown"]
  a.fv__ui-dropdown-toggler
  button.fv__ui-dropdown-caret:after,
a.more-dropdown > a.fv__ui-dropdown-toggler > .fv__ui-dropdown-caret:after,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret:after,
a[name="password-protect-controllers"] .fv__icon-toolbar-caret:after,
div[name="edit-object-ribbon-dropdown"]:before {
  position: absolute;
  right: 11px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  top: 17px;
  /* top: 50%;
  transform: translateY(-50%); */
  width: 12px;
  height: 12px;
}
div[name="edit-object-ribbon-dropdown"]:before {
  right: 15px;
}
a[name="password-protect-controllers"] .fv__icon-toolbar-caret:after,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret:after,
a[name="create-shape-dropdown"]
  a.fv__ui-dropdown-toggler
  button.fv__ui-dropdown-caret:after,
a[name="freetext-textbox"] button.fv__ui-dropdown-caret:after {
  /* position: relative;
  content: "";
  background-image: url(../src/assets/icons/Vector.svg) !important;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  width: 12px;
  height: 12px;
  display: inline-block;
  vertical-align: text-top;
  margin-left: 5px; */
  right: 4px;
}

.fv__ui-dropdown-toggler {
  padding: 2px 0 !important;
}
.fv__ui-dropdown-editor {
  height: auto !important;
}
.fv__ui-editable-dropdown .fv__ui-dropdown-toggler {
  border: none !important;
}

.pdfMenu > :nth-child(n) {
  position: relative;
  box-shadow: 0 0 0px 1px #ececec;
}

button.open-file .fv__ui-button-text {
  display: block;
  text-indent: -99999px;
}

a.more-dropdown li[name="download-file-button"] .fv__ui-button-icon:before,
a[name="dropdown-zoom"]
  .fv__ui-dropdown-toggler
  .fv__icon-toolbar-zoom-out:before,
a[name="dropdown-zoom"]
  .fv__ui-dropdown-toggler
  .fv__icon-toolbar-zoom-in:before,
a[name="password-protect-controllers"] .fv__ui-dropdown-icon:before,
button.open-file:before {
  position: relative;
  content: "";
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 25px;
  height: 25px;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}

button.open-file:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

a.more-dropdown li[name="download-file-button"] .fv__ui-button-icon:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

a[name="dropdown-zoom"]
  .fv__ui-dropdown-toggler
  .fv__icon-toolbar-zoom-out:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  left: 5px !important;
}

a[name="dropdown-zoom"]
  .fv__ui-dropdown-toggler
  .fv__icon-toolbar-zoom-in:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  left: 2px !important;
}
.fv__ui-contextmenu .fv__ui-dropdown {
  padding: 0.2rem 1.4rem;
  color: #444;
}
.fv__ui-contextmenu .fv__ui-dropdown .fv__ui-dropdown-item-text {
  margin-left: 0 !important;
}
.fv__ui-button-text {
}

a[name="freetext-textbox"] a.fv__ui-dropdown-toggler:before,
a.image-dropdown a.fv__ui-dropdown-toggler:before,
.fx-ribbon-item[name="create-shapeObject-dropdown"]:before,
.fx-ribbon-item[name="image-tool"]:before,
button[name="create-link"] i.fv__ui-button-icon:before,
.fx-ribbon-item[name="edit-text"] .fx-ribbon-item-icon:before,
.fx-ribbon-item[name="find-replace"] .fx-ribbon-item-icon:before,
a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler:before,
a[name="create-shape-dropdown"] a.fv__ui-dropdown-toggler:before,
a[name="dropdown-zoom"]
  .fv__ui-dropdown-toggler
  .fv__icon-toolbar-zoom-out:before,
button[name="download-file-button"] .fv__icon-toolbar-download:before,
a.more-dropdown > .fv__ui-dropdown-toggler:before,
li[text="Merge File"] .fv__ui-button-text:before,
li[text="Convert File"] .fv__ui-button-text:before,
/* .edit-object-ribbon-dropdown:before, */
.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > li:before {
  position: absolute;
  content: "";
  background-position: 100% 100%;
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
}

/* Before element */

li[text="Merge File"] .fv__ui-button-text:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  left: 0;
}
li[text="Convert File"] .fv__ui-button-text:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  left: 0;
}

a.more-dropdown > .fv__ui-dropdown-toggler:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  width: 20px;
  height: 30px;
  z-index: 4;
  pointer-events: none;
}

button[name="download-file-button"] .fv__icon-toolbar-download:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  left: 9px;
}

a[name="password-protect-controllers"] .fv__ui-dropdown-icon:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  margin-right: 5px;
  z-index: 4;
}

a.more-dropdown li.open-file .fv__ui-button-text,
a.more-dropdown li[name="download-file-button"] .fv__ui-button-text,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler-text,
a[name="password-protect-controllers"] .fv__ui-dropdown-toggler-text,
button[name="download-file-button"] .fv__ui-button-text,
a.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text,
li[text="Merge File"] .fv__ui-button-text,
li[text="Convert File"] .fv__ui-button-text {
  color: #2e2e2e !important;
  font-size: 18px !important;
  display: block !important;
  margin-left: 0 !important;
  text-transform: capitalize;
}
/* a[name="dropdown-zoom"] .fv__ui-dropdown-toggler-text {
  margin-left: 20px !important;
} */

a[name="password-protect-controllers"] .fv__ui-dropdown-toggler-text,
button[name="download-file-button"] .fv__ui-button-text,
a.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {
  text-align: center !important;
  width: 100% !important;
}
a[name="password-protect-controllers"] .fv__ui-dropdown-toggler-text {
  margin-right: 15px !important;
  z-index: 4;
  pointer-events: none;
}
li[text="Merge File"] .fv__ui-button-text,
li[text="Convert File"] .fv__ui-button-text {
  text-align: left !important;
  width: 100% !important;
  padding-left: 35px !important;
}
a.more-dropdown li.open-file .fv__ui-button-text,
a.more-dropdown li[name="download-file-button"] .fv__ui-button-text,
a[name="dropdown-zoom"] .fv__ui-dropdown-toggler-text {
  text-align: left !important;
  flex: 0 0 auto !important;
}

a.fv__ui-sign-dropdown .fv__ui-dropdown-toggler:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  margin-top: -2px;
}

a[name="create-shape-dropdown"] a.fv__ui-dropdown-toggler:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  left: 6px;
  pointer-events: none;
}

a.image-dropdown a.fv__ui-dropdown-toggler:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  z-index: 4;
  pointer-events: none;
}

a[name="freetext-textbox"] a.fv__ui-dropdown-toggler:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  left: 5px;
  pointer-events: none;
}

.fx-icon-ribbon_edit_add_images-32 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) !important;
  height: 25px !important;
  width: 25px !important;
  margin: 0 7px !important;
}

.fx-ribbon-item[name="create-shapeObject-dropdown"]:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.fx-ribbon-item[name="image-tool"]:before,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(3):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
div[name="edit-object-ribbon-dropdown"] .fv__icon-menu-edit,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(1):before {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
button[name="create-link"] i.fv__ui-button-icon {
  background-image: none !important;
}

button[name="create-link"] i.fv__ui-button-icon:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  left: 10px;
}
.fx-ribbon-item[name="edit-text"] .fx-ribbon-item-icon:before,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(2):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.fv__icon-menu-add-text {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
  width: 25px !important;
  height: 25px !important;
  margin: 0 7px !important;
}
.fx-ribbon-item[name="find-replace"] .fx-ribbon-item-icon:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: cover;
}
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(4):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
/* After element */
a[name="freetext-textbox"]:after,
a[name="create-shape-dropdown"]:after,
a.image-dropdown:after,
.fx-ribbon-item[name="edit-text"]:after,
.fx-ribbon-item[name="find-replace"]:after,
button[name="create-link"]:after,
.fx-ribbon-item[name="image-tool"]:after,
.fx-ribbon-item[name="create-shapeObject-dropdown"]:after,
button.open-file:after,
a.fv__ui-sign-dropdown:after,
a[name="dropdown-zoom"]:after,
.fx-ribbon-item[name="edit-object-ribbon-dropdown"]:after {
  position: absolute;
  color: #2e2e2e;
  font-size: 18px;
  right: 20px;
  top: 50%;
  transform: translate(0, -50%);
}
.fx-ribbon-item[name="edit-object-ribbon-dropdown"]:after {
  right: 36px;
}
a.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {
  padding-left: 15px;
  z-index: 4;
  pointer-events: none;
}

a.more-dropdown > .fv__ui-dropdown-list {
  padding: 0 !important;
  min-width: 220px !important;
}
.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list {
  top: 25px !important;
  right: 0px !important;
  padding: 0px !important;
  min-width: 185px !important;
}
a.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button,
a[name="freetext-textbox"] {
  height: auto !important;
  display: block !important;
  position: static !important;
  width: 100% !important;
}
a[name="freetext-textbox"],
a[name="create-shape-dropdown"] {
  height: 56px !important;
}
a.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button {
  padding: 14px 7px !important;
}
a[name="password-protect-controllers"] ul.fv__ui-dropdown-list .fv__ui-button {
  border-radius: 0.5rem !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
a[name="freetext-textbox"] {
  position: relative !important;
}
a.more-dropdown li[name="download-file-button"] .fv__ui-button-icon {
  background: none;
}

button.open-file:after {
  content: "Open File";
  right: 15px;
}

button.new-file:after {
  content: "New File";
  right: 15px;
}

a[name="create-shape-dropdown"]:after {
  content: "Shapes";
  right: auto;
  left: 40px;
  pointer-events: none;
}
a.fv__ui-sign-dropdown:after {
  content: "Sign";
  right: 38px;
  pointer-events: none;
}
a.image-dropdown:after {
  content: "Image";
  right: 40px;
  z-index: 4;
  pointer-events: none;
}
a[name="freetext-textbox"]:after {
  content: "Forms";
  right: auto;
  left: 40px;
  pointer-events: none;
}

.fx-ribbon-item[name="edit-text"]:after {
  content: "Edit Text";
}
.fx-ribbon-item[name="edit-object-ribbon-dropdown"]:after {
  content: "Content";
}
.fx-ribbon-item[name="find-replace"]:after {
  content: "Search \\A & Replace";
  white-space: pre; /* or pre-wrap */
  line-height: 1.2;
}
button[name="create-link"]:after {
  content: "Link";
}
.fx-ribbon-item[name="image-tool"]:after {
  content: "Image";
  right: 10px;
}
.fx-ribbon-item[name="create-shapeObject-dropdown"]:after {
  content: "Shapes";
  right: 0;
}
a[name="create-shape-dropdown"] .fv__ui-dropdown-list,
a[name="dropdown-zoom"] .fv__ui-dropdown-list {
  right: 0px !important;
  height: 13rem;
  overflow: auto;
}
a[name="dropdown-zoom"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {
  border-radius: 0.5rem !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
a[name="create-shape-dropdown"]
  .fv__ui-dropdown-list
  > li.fv__ui-dropdown-button {
  border-radius: 0.5rem !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
a[name="password-protect-controllers"] .fv__ui-dropdown-list {
  right: 0px !important;
}
.fv__ui-mobile .fv__ui-layer-header-inner {
  padding: 0.6875rem 0 !important;
}
.fv__ui-addon-font-size-dropdown .fv__ui-dropdown-list,
.fv__ui-addon-font-family-dropdown .fv__ui-dropdown-list {
  right: 0px !important;
}
@media (max-width: 991px) {
  a[name="dropdown-zoom"] .fv__ui-dropdown-toggler-text {
    margin-left: 15px !important;
  }
  a[name="dropdown-zoom"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {
    line-height: 1.3 !important;
    padding: 5px 7px !important;
  }
  a[name="password-protect-controllers"] .fv__ui-dropdown-toggler-text,
  li[text="Convert File"] .fv__ui-button-text,
  a[name="create-shape-dropdown"]:after,
  a[name="freetext-textbox"]:after,
  li[text="Merge File"] .fv__ui-button-text,
  a[name="dropdown-zoom"] .fv__ui-dropdown-toggler-text {
    font-size: 16px !important;
  }
  a.more-dropdown > .fv__ui-dropdown-list {
    min-width: 200px;
  }
  button[name="create-link"] i.fv__ui-button-icon {
    width: 100%;
  }
  a.more-dropdown .fv__ui-dropdown-list .fv__ui-dropdown-toggler {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  a.image-dropdown:after,
  .fx-ribbon-item[name="edit-text"]:after,
  .fx-ribbon-item[name="find-replace"]:after,
  button[name="create-link"]:after,
  .fx-ribbon-item[name="image-tool"]:after,
  .fx-ribbon-item[name="create-shapeObject-dropdown"]:after,
  button.open-file:after,
  a.fv__ui-sign-dropdown:after,
  a[name="dropdown-zoom"]:after,
  button[name="download-file-button"] .fv__ui-button-text,
  a.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {
    display: none !important;
  }
  button[name="download-file-button"],
  a[name="create-shape-dropdown"],
  a.image-dropdown,
  a.fv__ui-sign-dropdown,
  a[name="freetext-textbox"],
  a[name="password-protect-controllers"],
  a[name="dropdown-zoom"],
  a[name="freetext-textbox"],
  .fx-ribbon-item[name="image-tool"],
  .fx-ribbon-item[name="create-shapeObject-dropdown"],
  a.more-dropdown {
    min-width: 75px !important;
  }

  button[name="create-link"],
  .fx-ribbon-item[name="edit-text"],
  .fx-ribbon-item[name="find-replace"],
  button[name="hand-tool"],
  button.open-file {
    width: 50px !important;
    min-width: 55px !important;
  }

  .pdfMenu > :nth-child(n) {
    height: 50px !important;
    border-bottom: 1px solid #ececec;
  }

  a[name="freetext-textbox"] ul.fv__ui-dropdown-list .fx-ribbon-item {
    margin: 0 10px !important;
  }
  a[name="freetext-textbox"] ul.fv__ui-dropdown-list {
    padding-left: 3px;
    padding-right: 3px;
  }
  button[name="download-file-button"] .fv__icon-toolbar-download:before,
  button[name="create-link"] i.fv__ui-button-icon:before {
    left: 50%;
    transform: translate(-50%, -50%);
  }
  button.open-file:before {
    margin: 0 auto;
  }
  .fx-ribbon-item[name="edit-text"],
  button[name="create-link"],
  .fx-ribbon-item[name="image-tool"],
  .fx-ribbon-item[name="create-shapeObject-dropdown"],
  .pdfMenu > :nth-child(n) {
    width: 60px !important;
  }
  .more-dropdown .fv__ui-dropdown-list {
    right: 130px !important;
  }
  a[name="dropdown-zoom"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  a[name="freetext-textbox"] ul.fv__ui-dropdown-list {
    right: 0.25rem !important;
    width: 250px;
  }
}
.fv__ui-sign-dropdown-list {
  width: 180px !important;
}
.fv__ui-sign-dropdown-list .fv__ui-sign-list {
  margin-bottom: 0px !important;
}
.fx-ribbon-item {
  display: flex !important;
  align-items: center !important;
}
.fx-ribbon-item-text {
  display: flex;
  align-items: center;
}
.fx-ribbon-item-text > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.fx-ribbon-item-text {
  padding-right: 0.375rem;
  color: #2e2e2e;
  font-size: 18px !important;
}
.touchup_handler_container {
  z-index: 10 !important;
}

a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:after {
  display: none !important;
}
a[name="signature-dropdown"]
  ul.fv__ui-dropdown-list
  li.fv__ui-dropdown-button:before,
a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {
  width: 140px !important;
  font-size: 14px;
  height: 48px;
}

.fv__ui-dropdown-button i {
  display: none !important;
}
.fv__ui-dropdown-list > li.fv__ui-dropdown-button {
  min-width: 150px !important;
}
.t_1 .fv__ui-button {
  width: 1.5rem !important;
}
.jc_sb .fv__ui-button {
  width: 100% !important;
}
.d_f {
  align-items: center;
}
#ribbon-text_unique_liodsvnh_8 {
}

div[name="fv--plugin-PageEditor-add-image"] .fx-ribbon-item-text:after {
  content: "Add Image" !important;
  white-space: pre;
  line-height: 1.2;
}
div[name="fv--plugin-PageEditor-add-image"]
  .fx-ribbon-item-text
  .fx-ribbon-item-text-1 {
  display: none;
}
div[name="fv--plugin-PageEditor-add-image"]
  .fx-ribbon-item-text
  .fx-ribbon-item-text-2 {
  display: none;
}
div[name="fv--plugin-PageEditor-add-text"] .fx-ribbon-item-text,
div[name="fv--plugin-PageEditor-add-image"] .fx-ribbon-item-text {
  padding-top: 0.25rem;
}

/* .edit-object-ribbon-dropdown .fx-ribbon-item-icon, */
.edit-object-ribbon-dropdown .fx-ribbon-item-more,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:last-child,
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li:nth-child(2) {
  display: none;
}
.edit-object-ribbon-dropdown
  a.fv__ui-dropdown
  > .fv__ui-dropdown-list
  > li
  .fv__ui-dropdown-item-text {
  color: #2e2e2e;
  margin-left: 2.5rem;
  font-size: 18px !important;
}
div[name="edit-object-ribbon-dropdown"] .fx-ribbon-item-icon {
  margin-bottom: 0.25rem;
  margin-left: 0.75rem;
}
.pdfMenu.fv__ui-toolbar {
  overflow: visible !important;
}
.fv__ui-dropdown-list {
  position: relative !important;
  top: 0px !important;
  left: auto !important;
  right: 60px;
}
@media (max-width: 768px) {
  .fv__ui-directive-lazy-content {
    position: absolute !important;
    bottom: 0px !important;
    z-index: 100 !important;
    height: 30rem !important;
    width: 100% !important;
  }

  .fv__ui-directive-lazy-content .body {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
  .edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list {
    top: 1.6rem !important;
  }
  .fv__ui-mobile .fv__pdf-view-mode-item {
    margin: 0.5rem !important;
  }
  .fv__ui-directive-draggable {
    margin-left: auto;
    margin-right: auto;
    width: 38rem;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }
  div[name="create-signature"] .fv__ui-layer-header {
    padding: 10px 15px;
    margin: -23px -12px 0;
  }
  .fv__ui-layer .footer .fv__ui-dialog-ok-button,
  .fv__ui-layer .footer .fv__ui-dialog-cancel-button,
  .fv__password-protect-popup
    .document-permission-wrapper-inner
    .permission-edit-btn,
  .fv__ui-sign-dialog-tab-panel
    .fv__ui-sign-dialog-panel[name="sign-dialog-panel-type"]
    .type-body
    .customInput
    .addList {
    min-height: 46px !important;
    border-radius: 8px !important;
  }
  .fv__ui-mobile .fv__ui-sign-layer {
    min-width: 93% !important;
  }
  .fv__ui-mobile .fv__ui-layer {
    max-width: 93% !important;
  }
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col {
    flex-direction: column;
    gap: 0.75rem;
  }
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col
    .fv__appearance-dialog-col-item {
    display: flex;
    width: 100% !important;
  }
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col
    .fv__appearance-dialog-col-item
    .fv__appearance-dialog-label {
    display: flex !important;
    align-items: center;
  }
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col
    .fv__appearance-dialog-col-item
    .fv__ui-select,
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col
    .fv__appearance-dialog-col-item
    input,
  .fv__ui-annot-actions-dialog
    .fv__ui-layer-inner
    .fv__link-dialog-container
    .fv__appearance-dialog-container
    .fv__appearance-dialog-body
    .fv__appearance-dialog-col
    .fv__appearance-dialog-col-item
    select {
    width: 180px !important;
  }
}
@media (max-width: 400px) {
  .fv__ui-mobile .fv__ui-sign-dialog-footer {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1.5rem !important;
  }
  .fv__ui-mobile .fv__ui-sign-dialog-btns {
    margin-left: 0px !important;
  }
  .fv__ui-sign-dialog-tab-panel
    .fv__ui-sign-dialog-panel[name="sign-dialog-panel-type"]
    .type-body
    .customInput
    .addList {
    min-width: 5.75rem !important;
  }
}

.fv__ui-button-icon,
.fv__icon-toolbar-hand {
  font-size: 22px !important;
  font-weight: 600 !important;
}



.fv__annot-container-zindex-up .fv__pdf-page-handler-container{
  z-index: 10 !important;
}


.grecaptcha-badge {
  bottom: 1rem !important;
}


@media (min-width: 768px) {

  .grecaptcha-badge {
    bottom: 5rem !important;
  }
}

.pdfMenu:before,
.pdfMenu:after{
  background-color: none !important;
  display: none !important;
}

.hover\\:btn-gray:hover {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1;
  color: rgb(29 28 28 / var(--tw-text-opacity));
}

.hover\\:btn-gray:hover:hover {
  background-color: rgb(235 235 235 / 0.5);
}

.hover\\:btn-gray:hover:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 235 / var(--tw-border-opacity));
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1 !important;
  color: rgb(147 146 146 / var(--tw-text-opacity)) !important;
}

.hover\\:btn-gray:hover:disabled:hover {
  border-color: rgb(235 235 235 / 0.5);
  background-color: rgb(235 235 235 / 0.5);
  --tw-text-opacity: 1;
  color: rgb(147 146 146 / var(--tw-text-opacity));
}

.hover\\:border:hover {
  border-width: 1px !important;
}

.hover\\:\\!bg-danger-light\\/30:hover {
  background-color: rgb(255 209 209 / 0.3) !important;
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-grey-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity)) !important;
}

.hover\\:bg-secondary-80:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity)) !important;
}

.hover\\:\\!text-primary:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(94 94 210 / var(--tw-text-opacity)) !important;
}

.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(94 94 210 / var(--tw-text-opacity)) !important;
}

.hover\\:text-secondary-900:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(38 37 37 / var(--tw-text-opacity)) !important;
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

.focus\\:border-primary:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(94 94 210 / var(--tw-border-opacity)) !important;
}

.focus\\:border-secondary-1000:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(46 46 46 / var(--tw-border-opacity)) !important;
}

.focus\\:shadow-primary:focus {
  --tw-shadow-color: #5E5ED2 !important;
  --tw-shadow: var(--tw-shadow-colored) !important;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

@media (min-width: 640px) {

  .sm\\:col-span-12 {
    grid-column: span 12 / span 12 !important;
  }

  .sm\\:col-span-6 {
    grid-column: span 6 / span 6 !important;
  }

  .sm\\:mb-16 {
    margin-bottom: 4rem !important;
  }

  .sm\\:inline-block {
    display: inline-block !important;
  }

  .sm\\:grid {
    display: grid !important;
  }

  .sm\\:h-10 {
    height: 2.5rem !important;
  }

  .sm\\:h-6 {
    height: 1.5rem !important;
  }

  .sm\\:h-\\[28rem\\] {
    height: 28rem !important;
  }

  .sm\\:h-screen {
    height: 100vh !important;
  }

  .sm\\:\\!w-\\[40rem\\] {
    width: 40rem !important;
  }

  .sm\\:w-10 {
    width: 2.5rem !important;
  }

  .sm\\:w-6 {
    width: 1.5rem !important;
  }

  .sm\\:w-\\[31\\.125rem\\] {
    width: 31.125rem !important;
  }

  .sm\\:w-\\[40rem\\] {
    width: 40rem !important;
  }

  .sm\\:w-full {
    width: 100% !important;
  }

  .sm\\:max-w-\\[22\\.875rem\\] {
    max-width: 22.875rem !important;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap !important;
  }

  .sm\\:justify-between {
    justify-content: space-between !important;
  }

  .sm\\:gap-0 {
    gap: 0px !important;
  }

  .sm\\:gap-16 {
    gap: 4rem !important;
  }

  .sm\\:gap-y-3 {
    row-gap: 0.75rem !important;
  }

  .sm\\:gap-y-6 {
    row-gap: 1.5rem !important;
  }

  .sm\\:px-14 {
    padding-left: 3.5rem !important;
    padding-right: 3.5rem !important;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .sm\\:py-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .sm\\:py-3\\.5 {
    padding-top: 0.875rem !important;
    padding-bottom: 0.875rem !important;
  }

  .sm\\:align-middle {
    vertical-align: middle !important;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem !important;
    line-height: 1.5 !important;
  }

  .sm\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5 !important;
  }
}

@media (min-width: 768px) {

  .md\\:order-1 {
    order: 1 !important;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7 !important;
  }

  .md\\:my-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem !important;
  }

  .md\\:mt-16 {
    margin-top: 4rem !important;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem !important;
  }

  .md\\:block {
    display: block !important;
  }

  .md\\:flex {
    display: flex !important;
  }

  .md\\:h-16 {
    height: 4rem !important;
  }

  .md\\:h-40 {
    height: 10rem !important;
  }

  .md\\:h-6 {
    height: 1.5rem !important;
  }

  .md\\:w-16 {
    width: 4rem !important;
  }

  .md\\:w-40 {
    width: 10rem !important;
  }

  .md\\:w-6 {
    width: 1.5rem !important;
  }

  .md\\:max-w-sm {
    max-width: 24rem !important;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:flex-row {
    flex-direction: row !important;
  }

  .md\\:justify-start {
    justify-content: flex-start !important;
  }

  .md\\:gap-0 {
    gap: 0px !important;
  }

  .md\\:gap-20 {
    gap: 5rem !important;
  }

  .md\\:gap-4 {
    gap: 1rem !important;
  }

  .md\\:gap-5 {
    gap: 1.25rem !important;
  }

  .md\\:gap-6 {
    gap: 1.5rem !important;
  }

  .md\\:gap-8 {
    gap: 2rem !important;
  }

  .md\\:gap-y-10 {
    row-gap: 2.5rem !important;
  }

  .md\\:p-2 {
    padding: 0.5rem !important;
  }

  .md\\:p-2\\.5 {
    padding: 0.625rem !important;
  }

  .md\\:p-4 {
    padding: 1rem !important;
  }

  .md\\:p-5 {
    padding: 1.25rem !important;
  }

  .md\\:p-6 {
    padding: 1.5rem !important;
  }

  .md\\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .md\\:py-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .md\\:py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .md\\:py-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .md\\:pt-5 {
    padding-top: 1.25rem !important;
  }

  .md\\:\\!text-base {
    font-size: 1rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-2xl {
    font-size: 1.5rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-3xl {
    font-size: 1.875rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-lg {
    font-size: 1.125rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-sm {
    font-size: 0.875rem !important;
    line-height: 1.5 !important;
  }

  .md\\:text-xl {
    font-size: 1.25rem !important;
    line-height: 1.5 !important;
  }

  .md\\:leading-tight {
    line-height: 1.25 !important;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2 !important;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3 !important;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5 !important;
  }

  .lg\\:mt-32 {
    margin-top: 8rem !important;
  }

  .lg\\:max-w-md {
    max-width: 28rem !important;
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .lg\\:justify-start {
    justify-content: flex-start !important;
  }

  .lg\\:gap-5 {
    gap: 1.25rem !important;
  }

  .lg\\:gap-y-0 {
    row-gap: 0px !important;
  }

  .lg\\:rounded-l-2xl {
    border-top-left-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
  }

  .lg\\:rounded-r-2xl {
    border-top-right-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
  }

  .lg\\:p-12 {
    padding: 3rem !important;
  }

  .lg\\:py-26 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }

  .lg\\:py-28 {
    padding-top: 7rem !important;
    padding-bottom: 7rem !important;
  }

  .lg\\:text-left {
    text-align: left !important;
  }

  .lg\\:text-right {
    text-align: right !important;
  }
}

@media (min-width: 1280px) {

  .xl\\:right-0 {
    right: 0px !important;
  }

  .xl\\:block {
    display: block !important;
  }

  .xl\\:w-32 {
    width: 8rem !important;
  }

  .xl\\:w-36 {
    width: 9rem !important;
  }

  .xl\\:gap-6 {
    gap: 1.5rem !important;
  }

  .xl\\:px-16 {
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .xl\\:px-8 {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  .xl\\:text-7xl {
    font-size: 4.5rem !important;
    line-height: 1.5 !important;
  }

  .xl\\:text-\\[15px\\] {
    font-size: 15px !important;
  }
}

@media (min-width: 1441px) {

  .\\32xl\\:top-18 {
    top: 4.5rem !important;
  }

  .\\32xl\\:h-12 {
    height: 3rem !important;
  }

  .\\32xl\\:w-12 {
    width: 3rem !important;
  }

  .\\32xl\\:gap-10 {
    gap: 2.5rem !important;
  }

  .\\32xl\\:gap-8 {
    gap: 2rem !important;
  }

  .\\32xl\\:gap-x-11 {
    column-gap: 2.75rem !important;
  }

  .\\32xl\\:p-3 {
    padding: 0.75rem !important;
  }

  .\\32xl\\:pl-3 {
    padding-left: 0.75rem !important;
  }

  .\\32xl\\:text-base {
    font-size: 1rem !important;
    line-height: 1.5 !important;
  }
}

@media (max-width: 500px) {

  .xs\\:w-full {
    width: 100% !important;
  }
}

@media (min-width: 1100px) {

  .lg-wide\\:absolute {
    position: absolute !important;
  }

  .lg-wide\\:top-18 {
    top: 4.5rem !important;
  }

  .lg-wide\\:ml-0 {
    margin-left: 0px !important;
  }

  .lg-wide\\:flex {
    display: flex !important;
  }

  .lg-wide\\:hidden {
    display: none !important;
  }

  .lg-wide\\:w-auto {
    width: auto !important;
  }

  .lg-wide\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg-wide\\:flex-row {
    flex-direction: row !important;
  }

  .lg-wide\\:items-center {
    align-items: center !important;
  }

  .lg-wide\\:justify-between {
    justify-content: space-between !important;
  }

  .lg-wide\\:gap-6 {
    gap: 1.5rem !important;
  }

  .lg-wide\\:gap-x-6 {
    column-gap: 1.5rem !important;
  }

  .lg-wide\\:border-t-2 {
    border-top-width: 2px !important;
  }

  .lg-wide\\:border-primary {
    --tw-border-opacity: 1 !important;
    border-color: rgb(94 94 210 / var(--tw-border-opacity)) !important;
  }

  .lg-wide\\:px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .lg-wide\\:pb-10 {
    padding-bottom: 2.5rem !important;
  }

  .lg-wide\\:pt-9 {
    padding-top: 2.25rem !important;
  }

  .lg-wide\\:shadow-9xl {
    --tw-shadow: 0px 25px 26px 0px #0000001A !important;
    --tw-shadow-colored: 0px 25px 26px 0px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
  }
}

.\\[\\&\\:\\:-webkit-calendar-picker-indicator\\]\\:cursor-pointer::-webkit-calendar-picker-indicator {
  cursor: pointer !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,qBAAc;IAAd,+DAAc;IAAd,kBAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,aAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB,WAAoB;EAApB,qBAAoB;EAApB,kBAAoB;EAApB,gBAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB;AAAoB;AAApB;EAAA,8BAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,qBAAoB;EAApB,wBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,uBAAoB;EAApB,qBAAoB;EAApB,sBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,YAAoB;IAApB,qBAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,iBAAoB;EAApB,oBAAoB;EAApB,oBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;UAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB,gDAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,4FAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,uDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB,2DAAoB;EAApB,uCAAoB;EAApB,4DAAoB;EAApB,uGAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB,oEAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,uDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,sDAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,sDAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,sDAAoB;EAApB,kBAAoB;EAApB,sDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wDAAoB;EAApB,kBAAoB;EAApB,wDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,wDAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,wDAAoB;EAApB,kBAAoB;EAApB,wDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,mDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,mDAAoB;EAApB,kBAAoB;EAApB,mDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,mDAAoB;EAApB,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,mDAAoB;EAApB,kBAAoB;EAApB,mDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,wCAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,wCAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,oCAAoB;EAApB,wCAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB,sBAAoB;EAApB,yDAAoB;EAApB,6BAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,6BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,+BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,cAAoB;EAApB,gBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,0BAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB,yDAAoB;EAApB,oBAAoB;EAApB,0CAAoB;EAApB,sCAAoB;EAApB,2DAAoB;EAApB,uGAAoB;EAApB,8BAAoB;EAApB,mBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,4FAAoB;EAApB,wBAAoB;EAApB,wDAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,uDAAoB;EAApB,6DAAoB;EAApB,mGAAoB;EAApB,uGAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,wBAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB,uBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,wBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,yBAAoB;UAApB,iBAAoB;EAApB,YAAoB;EAApB,8BAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB,8BAAoB;EAApB,uGAAoB;EAApB,8BAAoB;EAApB,mBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB,iEAAoB;EAApB,wEAAoB;EAApB,8GAAoB;EAApB;AAAoB;AAApB;EAAA,iCAAoB;EAApB,iEAAoB;EAApB,wEAAoB;EAApB,8GAAoB;EAApB;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB,UAAoB;EAApB,QAAoB;EAApB,WAAoB;EAApB,aAAoB;EAApB,YAAoB;EAApB,WAAoB;EAApB,mBAAoB;EAApB,uBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,gBAAoB;EAApB,eAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,YAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,aAAoB;EAApB,gDAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,wBAAoB;EAApB,sBAAoB;EAApB,yDAAoB;EAApB,kBAAoB;EAApB;AAAoB;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;EAAA,sBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA,wBAAoB;IAApB,kEAAoB;IAApB;EAAoB;AAAA;AAApB;EAAA,qBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,wBAAoB;EAApB,mBAAoB;EAApB,gBAAoB;EAApB,gBAAoB;EAApB,oBAAoB;EAApB;AAAoB;AACpB;EAAA,6BAAmB;EAAnB,qBAAmB;EAAnB,sBAAmB;EAAnB,qBAAmB;EAAnB,uBAAmB;EAAnB,2BAAmB;EAAnB,iCAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,yEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,6EAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,8GAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,uEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,wEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0FAAmB;EAAnB,8GAAmB;EAAnB;AAAmB;AAAnB;EAAA,wFAAmB;EAAnB,4GAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,+GAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,sHAAmB;EAAnB,oHAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,0RAAmB;UAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,0RAAmB;UAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AASnB;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;aACW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kDAAkD;EAClD,sDAAsD;EACtD,8BAA8B;EAC9B,mDAAmD;EACnD,8BAA8B;EAC9B,yDAAyD;EACzD,8BAA8B;EAC9B,yDAAyD;EACzD,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;AACA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAwC;EAAxC,oBAAwC;EAAxC,6CAAwC;AAC1C;;AAGE;EAAA,iBAA0D;EAA1D,kBAA0D;EAA1D,iBAA0D;EAA1D,kBAA0D;EAA1D;AAA0D;;AAA1D;;EAAA;IAAA,qBAA0D;IAA1D;EAA0D;AAAA;;AAA1D;;EAAA;IAAA,oBAA0D;IAA1D;EAA0D;AAAA;;AAA1D;;EAAA;IAAA,kBAA0D;IAA1D;EAA0D;AAAA;AAG1D;EAAA,iBAAqD;EAArD,kBAAqD;EAArD,gBAAqD;EAArD,kBAAqD;EAArD;AAAqD;AAArD;;EAAA;IAAA,qBAAqD;IAArD;EAAqD;AAAA;AAArD;;EAAA;IAAA,oBAAqD;IAArD;EAAqD;AAAA;AAArD;;EAAA;IAAA,kBAAqD;IAArD;EAAqD;AAAA;AAGrD;EAAA,eAAyD;EAAzD,gBAAyD;EAAzD,gBAAyD;EAAzD,oBAAyD;EAAzD;AAAyD;AAAzD;;EAAA;IAAA,mBAAyD;IAAzD;EAAyD;AAAA;AAGzD;EAAA,eAAoD;EAApD,gBAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;AAApD;;EAAA;IAAA,mBAAoD;IAApD;EAAoD;AAAA;;AAGtD;EACE;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yDAA2D;EAC3D,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;EAeE,oCAAoC;AACtC;;AAEA;;;;;;;;;;;EAWE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,aAAa;EACb,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;;;;;;;EAOE,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;;EAEE,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAGE;EAAA,sBAA4B;EAA5B,gCAA4B;EAA5B;AAA4B;AAG5B;EAAA;AAAa;AAMb;;;;EAAA,6BAAiB;EAAjB;AAAiB;AAGjB;EAAA;AAAgB;AAMhB;;;;EAAA,sBAAgB;EAAhB;AAAgB;AAElB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,0BAA0B;EAC1B,YAAY;EACZ,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;;;;;;;;;GASG;;AAEH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,QAAQ;EACR,+CAA+C;AACjD;AACA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,QAAQ;EACR,8CAA8C;AAChD;;AAEA;;;;;;;;;;EAUE,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;;;EAIE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;GAYG;AACH;EACE,oEAAqE;EACrE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,yDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;;;;;;EAQE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyCE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;EACd,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,6BAA6B;EAC7B,MAAM;EACN,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oEAAgE;EAChE,8BAA8B;EAC9B,4BAA4B;EAC5B,SAAS;EACT;gCAC8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;;;;;;EAME;;;;;;;;;qBASmB;EACnB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,yDAAmD;AACrD;;AAEA;EACE,yDAAuD;AACzD;;AAEA;;;EAGE,yDAAkD;EAClD,oBAAoB;AACtB;;AAEA;;;EAGE,yDAAiD;EACjD,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;AACA;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,6BAA6B;AAC/B;;AAEA,mBAAmB;;AAEnB;EACE,yDAAoD;EACpD,OAAO;AACT;AACA;EACE,0DAAsD;EACtD,OAAO;AACT;;AAEA;EACE,0DAAmD;EACnD,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0DAAmD;EACnD,SAAS;AACX;;AAEA;EACE,0DAAqD;EACrD,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;;;;;;EAQE,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EAEzB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;;GAEG;;AAEH;;;EAGE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,0DAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,0DAAqD;EACrD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,0DAAsD;EACtD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,0DAAyD;EACzD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qEAAiE;EACjE,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,0DAAiE;AACnE;AACA;;;;;EAKE,0DAAsD;AACxD;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,0DAAmD;AACrD;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,0DAAwD;EACxD,UAAU;AACZ;AACA;;;;;EAKE,0DAAwD;AAC1D;AACA;EACE,qEAAmE;EACnE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,0DAAqD;EACrD,sBAAsB;AACxB;AACA;;;;EAIE,0DAAqD;AACvD;AACA,kBAAkB;AAClB;;;;;;;;;;;;EAYE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,QAAQ;EACR,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AAEE;EAAA,oBAAgC;EAAhC,qBAAgC;EAAhC,uBAAgC;EAChC;AADgC;AAGlC;;EAGE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AAEE;EAAA,gCAA8B;EAA9B,2BAA8B;EAA9B,8BAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;AAEhC;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,gBAAgB,EAAE,gBAAgB;EAClC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AAGE;;EAAA,qBAAkC;EAAlC,aAAkC;EAAlC;AAAkC;AAGlC;EAAA,gCAAwB;EAAxB,2BAAwB;EAAxB;AAAwB;AAKxB;;;EAAA,gCAA4B;EAA5B,2BAA4B;EAA5B;AAA4B;AAG5B;EAAA;AAAe;AAEjB;EACE,+BAA+B;AACjC;AAGE;;EAAA;AAAe;AAEjB;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;;;;;;IAME,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;;;;;;;;;;;IAWE,wBAAwB;EAC1B;EACA;;;;;;;;;;;IAWE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;;IAEE,SAAS;IACT,gCAAgC;EAClC;EACA;IACE,cAAc;EAChB;EAME;;;;;IAAA;EAAgB;EAGhB;IAAA;EAAqB;EAGrB;IAAA,+BAAY;IAAZ;EAAY;EAGZ;IAAA,yBAAyB;IAAzB;EAAyB;AAE7B;AAEE;EAAA;AAAiB;AAGjB;EAAA;AAAY;AAGZ;EAAA,wBAAmC;EAAnC;AAAmC;AAGnC;EAAA,aAAyC;EAAzC;AAAyC;AAAzC;EAAA,uBAAyC;EAAzC,uDAAyC;EAAzC;AAAyC;AAAzC;EAAA,uBAAyC;EACzC,cAAc;EACd;AAFyC;AAI3C;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;AACA;;;;EAIE,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAGE;EAAA;AAAwB;AAE1B;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AAEE;EAAA;AAAmB;AAErB;AACA;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;AAIE;;;EAAA;AAAa;AAKb;;;EAAA;AAAa;AAIb;;EAAA;AAAW;;AAGb,uDAAuD;AAUrD;;;;;;;;;EAAA;AAAa;AAEf;;;;;EAKE,cAAc;EACd,mBAAmB;EACnB,0BAA0B;AAC5B;AAEE;EAAA,sBAAgB;EAAhB;AAAgB;AAGhB;EAAA;AAAwB;AAGxB;EAAA,6BAA+C;EAA/C,mBAA+C;EAA/C,qBAA+C;EAA/C;AAA+C;AAEjD;EAEI;IAAA,6BAA4D;IAA5D,sBAA4D;IAA5D,uBAA4D;IAA5D,wBAA4D;IAA5D;EAA4D;;EAI5D;IAAA,kBAAe;IAAf;EAAe;EAGf;IAAA;EAAoB;EAGpB;IAAA;EAAW;EAGX;IAAA,iBAAiC;IAAjC,kBAAiC;IAAjC,YAAiC;IAAjC,kBAAiC;IAAjC;EAAiC;EAEnC;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;;;;;;;;;;IAUE,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EAOE;;;;;;IAAA,sBAAqB;IAArB;EAAqB;EASrB;;;;;;;IAAA,aAAmB;IAAnB;EAAmB;EAUnB;;;;;;;;IAAA,wBAAyB;IAAzB;EAAyB;EA0BzB;;;;;;;;;;;;;;;;;;;;;;;;IAAA;EAAiB;AAErB;AACA;EAEI;IAAA,iCAAoC;IAApC,kCAAoC;IAApC;EAAoC;EAGpC;IAAA;EAAY;EAEd;;;;;IAKE,6BAA6B;EAC/B;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;AAC7B;;;;AAIA;EACE,sBAAsB;AACxB;;;AAIE;EAAA;AAAuC;;;AAAvC;;EAAA;IAAA;EAAuC;AAAA;;AAGzC;;EAEE,iCAAiC;EACjC,wBAAwB;AAC1B;;AA5+CA;EAAA,sBA4+CC;EA5+CD,yDA4+CC;EA5+CD,wCA4+CC;EA5+CD,oBA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA;AA4+CC;;AA5+CD;EAAA,sBA4+CC;EA5+CD,yDA4+CC;EA5+CD,wCA4+CC;EA5+CD,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,oCA4+CC;EA5+CD,wCA4+CC;EA5+CD,oBA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA;AA4+CC;;AA5+CD;EAAA;AA4+CC;;AA5+CD;EAAA,6BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,6BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,6BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,+BA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,iCA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,iCA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,qCA4+CC;EA5+CD;AA4+CC;;AA5+CD;EAAA,yCA4+CC;EA5+CD;AA4+CC;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,gCA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,0BA4+CC;IA5+CD;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,2BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,0BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,0BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,6BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,uCA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,wCA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,8BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,6BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,6BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,4BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,0BA4+CC;IA5+CD;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;AAAA;;AA5+CD;;EAAA;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,iCA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA,+BA4+CC;IA5+CD;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA;EA4+CC;;EA5+CD;IAAA,mDA4+CC;IA5+CD,wEA4+CC;IA5+CD;EA4+CC;AAAA;;AA5+CD;EAAA;AA4+CC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  @font-face {\n    font-family: \"Lexend\";\n    src: url(\"../src/assets/fonts/Lexend.ttf\") format(\"truetype\");\n    font-display: swap;\n  }\n}\nhtml, body, *{\n  font-family: \"Lexend\", sans-serif !important;\n}\n\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n}\n\ncode {\n  font-family: \"Lexend\", source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nbody {\n  min-width: 320px;\n  margin: 0;\n  padding: 0;\n  font-family: \"Lexend\", sans-serif;\n}\n\nbutton.outline {\n  border-color: #5e5ed2;\n  color: #5e5ed2;\n}\n\n:root {\n  /* Step 0: 28.00px → 48.00px */\n  --h1: clamp(1.75rem, calc(0.86rem + 2.38vw), 3rem);\n  --h1-custom: clamp(2rem, calc(0.86rem + 2.38vw), 3rem);\n  /* Step 0: 24.00px → 40.00px */\n  --h2: clamp(1.5rem, calc(1.16rem + 1.49vw), 2.5rem);\n  /* Step 0: 20.00px → 32.00px */\n  --h3: clamp(1.25rem, calc(0.4364rem + 1.6949vw), 1.75rem);\n  /* Step 0: 18.00px → 28.00px */\n  --h4: clamp(1.125rem, calc(0.8625rem + 1.1475vw), 1.5rem);\n  /* Step 0: 16.00px → 20.00px */\n  --h5: clamp(1rem, calc(0.4364rem + 1.6949vw), 1.25rem);\n  /* Step 0: 14.00px → 16.00px */\n  --h6: clamp(0.875rem, calc(0.4364rem + 1.6949vw), 1rem);\n}\n\n.h1-custom {\n  font-size: var(--h1-custom);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h1,\nh1 {\n  font-size: var(--h1);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h2,\nh2 {\n  font-size: var(--h2);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h3,\nh3 {\n  font-size: var(--h3);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h4,\nh4 {\n  font-size: var(--h4);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h5,\nh5 {\n  font-size: var(--h5);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n.h6,\nh6 {\n  font-size: var(--h6);\n  line-height: 1.25;\n  @apply text-secondary-1000 font-semibold;\n}\n\n.container-lg {\n  @apply max-w-[1920px] mx-auto px-4 md:px-5 lg:px-6 xl:px-8;\n}\n.container {\n  @apply max-w-8xl mx-auto px-4 md:px-5 lg:px-6 xl:px-8;\n}\np {\n  @apply text-base md:text-lg text-secondary-800 font-light;\n}\na {\n  @apply text-base md:text-lg text-primary font-medium;\n}\n\n@media (min-width: 640px) {\n  .sm\\:grid-rows-8 {\n    grid-template-rows: repeat(8, minmax(0, 1fr)) !important;\n  }\n}\n\n.btnClose > svg {\n  width: 2.2em;\n  height: 2.2em;\n}\n.btnClose:hover > svg > path {\n  stroke: #5e5ed2;\n}\n\nbutton[name=\"hand-tool\"] {\n  justify-content: center;\n}\n\n.fx-ribbon-item[name=\"find-replace\"] {\n  min-width: 145px !important;\n}\n\ndiv[name=\"find-replace-dialog\"] .fv__ui-dropdown-toggler {\n  padding: 0 !important;\n}\n\n.fx-ribbon-item[name=\"edit-text\"] .fx-ribbon-item-icon,\n.fx-ribbon-item[name=\"find-replace\"] .fx-ribbon-item-icon {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.OTPInputs input {\n  margin: 10px;\n  height: 45px;\n  width: 65px;\n  border: none;\n  border-radius: 5px;\n  text-align: center;\n  font-family: arimo;\n  font-size: 1.2rem;\n  background: #eef2f3;\n}\n\n.OTPInputs .container {\n  display: flex;\n  flex-flow: column;\n  height: 100%;\n  align-items: space-around;\n  justify-content: center;\n}\n\n.OTPInputs .userInput {\n  display: flex;\n  justify-content: center;\n}\n\n.dropDown svg {\n  opacity: 0;\n  visibility: hidden;\n}\n.dropDown:after {\n  position: absolute;\n  content: \"\";\n  background-image: url(\"../src/assets/icons/down-arrow.svg\");\n  background-repeat: no-repeat;\n  background-position: 100% 100%;\n  width: 15px;\n  height: 8px;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  margin-top: 2px;\n}\n\n.pdfMenu {\n  padding: 0 !important;\n  border: solid #e9e9e9;\n  border-width: 1px 0 1px 0;\n  overflow: hidden;\n}\n\n.fx-ribbon-item {\n  margin: 0 !important;\n}\n\n.fx-ribbon-item:hover,\n.fv__ui-button:not(.disabled):hover,\n.fv__ui-toolbar .fv__ui-dropdown-toggler.active,\n.fv__ui-toolbar .fv__ui-dropdown-toggler:hover,\na.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,\n.fx-ribbon-item-active,\na.more-dropdown.active,\na.more-dropdown:hover,\n.fv__ui-button.active,\n.fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,\n.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,\n.fv__ui-toolbar\n  .fv__ui-dropdown.active\n  > .fv__ui-dropdown-toggler\n  .fv__ui-dropdown-caret {\n  background-color: #bdbdfd !important;\n}\n\n.fv__ui-toolbar .fv__ui-dropdown.selected .fv__ui-dropdown-toggler,\n.fv__ui-toolbar\n  .fv__ui-dropdown.selected\n  .fv__ui-dropdown-toggler\n  .fv__ui-dropdown-caret,\n.image-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,\n.fv__ui-dropdown-list.fv__ui-sign-dropdown-list\n  .fv__ui-sign-item:not(.disabled):focus,\n.fv__ui-dropdown-list.fv__ui-sign-dropdown-list\n  .fv__ui-sign-item:not(.disabled):hover,\nli[name=\"create-signature-btn\"]:hover {\n  background-color: transparent !important;\n}\n\nbutton#component-lfw7vsaz > span {\n  color: #fff !important;\n}\n\n.fx-ribbon-item-icon {\n  overflow: visible !important;\n}\n\n.online-checkbox-inner {\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 4px !important;\n  background-color: #5e5ed2 !important;\n}\n.online-checkbox-inner:after {\n  border-bottom: 2px solid #ffff !important;\n  border-left: 0;\n  border-left-color: #ffff !important;\n  border-right: 2px solid #ffff !important;\n  border-top: 0;\n  border-top-color: #ffff !important;\n  left: 31% !important;\n}\n\na.image-dropdown .fv__ui-dropdown-caret {\n  position: absolute !important;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 1;\n}\n\na.image-dropdown ul.fv__ui-dropdown-list,\n.edit-object-ribbon-dropdown ul.fv__ui-dropdown-list,\na[name=\"password-protect-controllers\"] ul.fv__ui-dropdown-list,\na[name=\"signature-dropdown\"] ul.fv__ui-dropdown-list,\na[name=\"create-shape-dropdown\"] ul.fv__ui-dropdown-list,\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-list {\n  padding: 12px 12px !important;\n  min-width: auto !important;\n  border-radius: 10px;\n}\n\nbutton[name=\"download-file-button\"],\nbutton.open-file,\na[name=\"create-shape-dropdown\"],\na.image-dropdown,\na[name=\"freetext-textbox\"] {\n  min-width: 145px !important;\n}\n\na.more-dropdown,\na.fv__ui-sign-dropdown {\n  min-width: 125px !important;\n}\n\na[name=\"dropdown-zoom\"],\na[name=\"password-protect-controllers\"] {\n  display: block !important;\n  position: static !important;\n  width: 100% !important;\n  height: auto !important;\n}\n\na[name=\"create-shape-dropdown\"],\na[name=\"freetext-textbox\"] {\n  display: block !important;\n  position: relative !important;\n  width: 100% !important;\n  height: auto !important;\n  text-align: left;\n}\n\na.more-dropdown .fv__ui-dropdown-list .fv__ui-dropdown-toggler {\n  position: relative !important;\n  padding-left: 7px !important;\n  padding-right: 7px !important;\n  justify-content: flex-start !important;\n}\n\na.more-dropdown > .fv__ui-dropdown-list > *,\n.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > * {\n  border-bottom: 1px solid #ccc !important;\n  border-radius: 0;\n}\n.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > * {\n  height: 56px;\n}\n.fv__ui-dropdown-list > a:last-child,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(4) {\n  border-bottom: 0 !important;\n}\n\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list {\n  padding-top: 70px;\n  padding-bottom: 30px;\n}\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list .fx-ribbon-item {\n  display: inline-block;\n  vertical-align: middle;\n}\n\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list:before {\n  position: absolute;\n  content: \"Fill non interactive forms\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.25;\n  color: #2e2e2e;\n  top: -1px;\n  left: 0;\n  right: 0;\n  height: 44px;\n  background-color: #bdbdfd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list .fx-ribbon-item {\n  @apply !p-2 !m-0 !rounded-lg;\n}\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list .fx-ribbon-item:first-child {\n  @apply !mt-10;\n}\na[name=\"freetext-textbox\"]\n  ul.fv__ui-dropdown-list\n  .fx-ribbon-item\n  .fx-ribbon-item-text {\n  @apply !pr-0 pl-3;\n}\na[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list {\n  @apply w-[250px];\n}\na[name=\"password-protect-controllers\"]\n  ul.fv__ui-dropdown-list\n  .fv__ui-button\n  .fv__ui-dropdown-item-text {\n  @apply !p-0 !m-0;\n}\na.image-dropdown ul.fv__ui-dropdown-list {\n  min-height: 90px;\n}\na[name=\"signature-dropdown\"] ul.fv__ui-dropdown-list {\n  min-height: 10px;\n}\n.fv__ui-sign-list-icon-item {\n  padding: 5px 0;\n  border-bottom: 1px solid #ececec;\n}\n.fv__ui-sign-list {\n  margin-bottom: 10px;\n}\na.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button {\n  position: static;\n}\na[name=\"signature-dropdown\"]\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button:before,\na.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {\n  position: absolute;\n  background-color: #5e5ed2;\n  border-radius: 10px;\n  width: 182px;\n  height: 52px;\n  left: 50%;\n  bottom: 20px;\n  transform: translateX(-50%);\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.25;\n  text-align: center;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\na[name=\"signature-dropdown\"]\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button:before {\n  content: \"+ Add Signature\";\n  bottom: auto;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\na.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {\n  content: \"Upload Image\";\n}\n/* a.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:after {\n  position: absolute;\n  content: \"\";\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 1px;\n  transform: translateX(-50%);\n  background-color: #ececec;\n} */\n\ndiv[name=\"create-signature\"] .fv__ui-layer-header {\n  padding: 24px 20px;\n  text-align: center;\n  background: #5e5ed2;\n  margin: -23px -22px 0;\n  border-radius: 7px 7px 0 0;\n}\ndiv[name=\"create-signature\"] .fv__ui-layer-header .fv__ui-layer-header-title {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.25;\n  text-align: center;\n  color: #fff;\n}\ndiv[name=\"create-signature\"] .fv__ui-layer-header .fv__ui-layer-header-button {\n  position: relative;\n}\ndiv[name=\"create-signature\"]\n  .fv__ui-layer-header\n  .fv__ui-layer-header-button:before {\n  position: absolute;\n  background-color: #fff;\n  width: 20px;\n  height: 2px;\n  content: \"\";\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\ndiv[name=\"create-signature\"]\n  .fv__ui-layer-header\n  .fv__ui-layer-header-button:after {\n  position: absolute;\n  background-color: #fff;\n  width: 20px;\n  height: 2px;\n  content: \"\";\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.fv__ui-sign-dialog-tab-panel\n  .fv__ui-sign-dialog-panel[name=\"sign-dialog-panel-type\"]\n  .type-body\n  .customInput\n  .addList,\n.fv__ui-layer .footer .fv__ui-dialog-ok-button,\n.fv__ui-layer .footer .fv__ui-dialog-cancel-button,\n.fv__password-protect-popup\n  .document-permission-wrapper-inner\n  .permission-edit-btn {\n  border-color: #5e5ed2 !important;\n  background-color: #5e5ed2 !important;\n  border-radius: 10px !important;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px !important;\n  line-height: 1.25 !important;\n  text-align: center;\n  color: #fff !important;\n  align-items: center;\n  justify-content: center;\n  min-height: 52px !important;\n  height: auto !important;\n}\n\ndiv.password-protect-footer\n  > .fv__ui-layer\n  .footer\n  .fv__ui-dialog-ok-button:not(.disabled):hover {\n  color: #fff !important;\n  opacity: 0.3 !important;\n}\n\ndiv[name=\"create-signature\"] .fv__ui-layer-header .fv__ui-layer-header-inner {\n  margin-bottom: 0;\n}\n\ndiv.fv__ui-sign-dialog-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\na.image-dropdown\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__ui-button-text,\na[name=\"signature-dropdown\"]\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__ui-dropdown-item-text {\n  position: static;\n  width: 0;\n  height: 0;\n}\n\na.image-dropdown .fv__ui-button.active {\n  background: none !important;\n}\n\n/* a.image-dropdown\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__ui-button-text::after {\n  position: absolute;\n  content: \"\";\n  background-image: url(../src/assets/icons/Delete-icon.svg);\n  width: 30px;\n  height: 30px;\n  right: 20px;\n  top: 24%;\n  transform: translateY(-50%);\n} */\n.fv__icon-toolbar-delete-sign {\n  background-image: url(../src/assets/icons/Delete-icon.svg) !important;\n  position: absolute;\n  right: 20px;\n}\n\na.image-dropdown\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__icon-toolbar-image,\na[name=\"signature-dropdown\"]\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__icon-toolbar-add-sign {\n  position: static;\n  background-image: none;\n}\n\na.image-dropdown\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button\n  .fv__icon-toolbar-image:before {\n  position: absolute;\n  content: \"\";\n  background-image: url(../src/assets/placeholder.png);\n  width: 136px;\n  height: 55px;\n  left: 25px;\n  top: 24%;\n  transform: translateY(-50%);\n}\n\na[name=\"create-shape-dropdown\"] ul.fv__ui-dropdown-list .fx-icon-sm {\n  width: 1.5rem;\n  height: 1.5rem;\n}\na[name=\"create-shape-dropdown\"]\n  ul.fv__ui-dropdown-list\n  .fv__ui-dropdown-item-text {\n  margin-left: 1rem;\n}\n\na[name=\"create-shape-dropdown\"]\n  ul.fv__ui-dropdown-list\n  > li.fv__ui-dropdown-button {\n  height: 37px;\n}\n\na[name=\"create-shape-dropdown\"]\n  ul.fv__ui-dropdown-list\n  > li.fv__ui-dropdown-button,\na[name=\"password-protect-controllers\"]\n  ul.fv__ui-dropdown-list\n  > li.fv__ui-dropdown-button\n  span,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-item-text {\n  font-size: 16px !important;\n  line-height: 1.25 !important;\n}\n\n.fx-ribbon-item.active,\n.fx-ribbon-item.selected,\n.fv__ui-dropdown-list > li.fv__ui-dropdown-button:hover,\n.fv__ui-toolbar .fv__ui-dropdown.active,\n.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,\n.fx-ribbon-item:hover,\n.fv__ui-toolbar .fx-ribbon-item.fx-ribbon-item-active:focus,\n.fv__ui-toolbar .fv__ui-dropdown-toggler.active,\n.fv__ui-toolbar .fv__ui-dropdown-toggler:hover,\n.fv__ui-dropdown-caret:focus,\n.fv__ui-dropdown-icon:focus,\n.fv__ui-dropdown-list\n  > li.fv__ui-dropdown-button:not(.active):not(:hover):not(.disabled):focus,\n.fv__ui-dropdown-list\n  > li.fv__ui-dropdown-container-item:not(.active):not(:hover):not(\n    .disabled\n  ):focus,\n.fv__ui-dropdown-toggler:focus,\n.fv__ui-editable-dropdown .fv__ui-dropdown-caret:focus,\n.fv__ui-layer:not(.float-bar) .fv__ui-dropdown.active .fv__ui-dropdown-toggler,\n.fv__ui-layer:not(.float-bar)\n  .fv__ui-dropdown.selected\n  .fv__ui-dropdown-toggler,\n.fv__ui-toolbar .fv__ui-dropdown.active > .fv__ui-dropdown-toggler,\n.fv__ui-toolbar .fv__ui-dropdown.selected .fv__ui-dropdown-toggler,\n.fv__ui-toolbar\n  .fv__ui-dropdown.selected\n  .fv__ui-dropdown-toggler\n  .fv__ui-dropdown-caret,\n.fv__ui-toolbar\n  .fv__ui-dropdown.active\n  > .fv__ui-dropdown-toggler\n  .fv__ui-dropdown-caret,\n.fv__ui-dropdown-list.fv__ui-sign-dropdown-list\n  .fv__ui-sign-item:not(.disabled):hover,\n.fv__ui-dropdown-list.fv__ui-sign-dropdown-list\n  .fv__ui-sign-item:not(.disabled):focus,\n/* .fv__ui-button:not(.disabled):not(.active):focus, */\nbutton[name=\"create-link\"]:hover,\nbutton[name=\"download-file-button\"]:hover,\nbutton.open-file:hover {\n  border-radius: 0 !important;\n  outline: none !important;\n}\n\na.image-dropdown .fv__ui-dropdown-icon,\n.fv__ui-grouplist-item:after,\n.fv__ui-grouplist-item[name=\"edit-tab-group-hand\"],\n.fv__ui-grouplist-item[name=\"edit-tab-group-font\"],\n.fx-ribbon-item[name=\"fv--addon-add-text-button\"],\n.fx-ribbon-item[name=\"doc-attachment-button\"],\n.fx-ribbon-item[name=\"create-image\"],\n.fx-ribbon-item[name=\"multi-media-btn\"],\n.fx-ribbon-item[name=\"edit-text\"] .fx-ribbon-item-icon .fx-icon,\n.fx-ribbon-item[name=\"edit-text\"] .fx-icon-ribbon_home_editobject-32,\n.fx-ribbon-item[name=\"edit-text\"] .fx-ribbon-item-text,\n.fx-ribbon-item[name=\"create-link\"] .fx-ribbon-item-icon,\n.fx-ribbon-item[name=\"create-link\"] .fx-ribbon-item-text,\n.fx-ribbon-item[name=\"image-tool\"] .fx-ribbon-item-icon,\n.fx-ribbon-item[name=\"image-tool\"] .fx-ribbon-item-text,\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"] .fx-ribbon-item-icon,\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"] .fx-ribbon-item-text,\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-icon,\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler .fv__ui-dropdown-toggler-text,\na[name=\"open-file-button-list\"] button.fv__icon-toolbar-open,\na[name=\"freetext-textbox\"] .fv__icon-toolbar-textbox,\n.fx-ribbon-item[name=\"find-replace\"] .fx-ribbon-item-text,\n.fx-ribbon-item[name=\"find-replace\"] .fx-ribbon-item-icon .fx-icon,\n.edit-object-ribbon-dropdown .fx-ribbon-item-text {\n  display: none !important;\n}\n\na[name=\"freetext-textbox\"],\n.fx-ribbon-item[name=\"edit-text\"],\nbutton[name=\"create-link\"],\n.fx-ribbon-item[name=\"image-tool\"],\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"],\n.pdfMenu > :nth-child(n) {\n  background-image: none;\n  position: relative;\n  min-width: 105px;\n  width: 75px !important;\n  height: 48px !important;\n}\n.fx-ribbon-item[name=\"edit-text\"],\n.fx-ribbon-item[name=\"edit-object-ribbon-dropdown\"] {\n  min-width: 145px;\n}\n.fx-ribbon-item[name=\"fv--plugin-PageEditor-add-text\"] {\n  min-width: 125px;\n}\n.fx-ribbon-item[name=\"fv--plugin-PageEditor-add-image\"] {\n  min-width: 140px;\n}\nbutton[name=\"create-link\"] i.fv__ui-button-icon {\n  position: relative;\n  display: block;\n}\n\na[name=\"freetext-textbox\"] button.fv__ui-dropdown-caret,\na.image-dropdown button.fv__ui-dropdown-caret,\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-caret,\na[name=\"create-shape-dropdown\"]\n  a.fv__ui-dropdown-toggler\n  .fv__ui-dropdown-caret,\na[name=\"create-shape-dropdown\"] .fv__ui-dropdown-icon,\na[name=\"open-file-button-list\"] .fv__icon-toolbar-caret,\nbutton.open-file .fv__ui-button-text,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler .fv__icon-toolbar-zoom-out,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler .fv__icon-toolbar-zoom-in,\na[name=\"password-protect-controllers\"] .fv__icon-toolbar-caret,\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-icon,\nbutton[name=\"download-file-button\"] .fv__icon-toolbar-download,\na.more-dropdown .fv__ui-dropdown-caret {\n  flex-shrink: 0;\n  background-image: none !important;\n  position: static !important;\n}\n\na.more-dropdown .fv__ui-dropdown-caret {\n  left: 0;\n  right: 0;\n  width: 100% !important;\n  position: absolute !important;\n  top: 0;\n  bottom: 0;\n}\n\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-caret {\n  z-index: 1;\n}\n\na[name=\"freetext-textbox\"] button.fv__ui-dropdown-caret:after,\na.image-dropdown button.fv__ui-dropdown-caret:after,\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler i.fv__ui-dropdown-caret:after,\na[name=\"create-shape-dropdown\"]\n  a.fv__ui-dropdown-toggler\n  button.fv__ui-dropdown-caret:after,\na.more-dropdown > a.fv__ui-dropdown-toggler > .fv__ui-dropdown-caret:after,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret:after,\na[name=\"password-protect-controllers\"] .fv__icon-toolbar-caret:after,\ndiv[name=\"edit-object-ribbon-dropdown\"]:before {\n  position: absolute;\n  right: 11px;\n  content: \"\";\n  background-image: url(../src/assets/icons/Vector.svg) !important;\n  background-position: 100% 100%;\n  background-repeat: no-repeat;\n  top: 17px;\n  /* top: 50%;\n  transform: translateY(-50%); */\n  width: 12px;\n  height: 12px;\n}\ndiv[name=\"edit-object-ribbon-dropdown\"]:before {\n  right: 15px;\n}\na[name=\"password-protect-controllers\"] .fv__icon-toolbar-caret:after,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler .fv__icon-toolbar-caret:after,\na[name=\"create-shape-dropdown\"]\n  a.fv__ui-dropdown-toggler\n  button.fv__ui-dropdown-caret:after,\na[name=\"freetext-textbox\"] button.fv__ui-dropdown-caret:after {\n  /* position: relative;\n  content: \"\";\n  background-image: url(../src/assets/icons/Vector.svg) !important;\n  background-position: 100% 100%;\n  background-repeat: no-repeat;\n  width: 12px;\n  height: 12px;\n  display: inline-block;\n  vertical-align: text-top;\n  margin-left: 5px; */\n  right: 4px;\n}\n\n.fv__ui-dropdown-toggler {\n  padding: 2px 0 !important;\n}\n.fv__ui-dropdown-editor {\n  height: auto !important;\n}\n.fv__ui-editable-dropdown .fv__ui-dropdown-toggler {\n  border: none !important;\n}\n\n.pdfMenu > :nth-child(n) {\n  position: relative;\n  box-shadow: 0 0 0px 1px #ececec;\n}\n\nbutton.open-file .fv__ui-button-text {\n  display: block;\n  text-indent: -99999px;\n}\n\na.more-dropdown li[name=\"download-file-button\"] .fv__ui-button-icon:before,\na[name=\"dropdown-zoom\"]\n  .fv__ui-dropdown-toggler\n  .fv__icon-toolbar-zoom-out:before,\na[name=\"dropdown-zoom\"]\n  .fv__ui-dropdown-toggler\n  .fv__icon-toolbar-zoom-in:before,\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-icon:before,\nbutton.open-file:before {\n  position: relative;\n  content: \"\";\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n  width: 25px;\n  height: 25px;\n  background-repeat: no-repeat;\n  background-position: 100% 100%;\n}\n\nbutton.open-file:before {\n  background-image: url(../src/assets/icons/open.svg);\n}\n\na.more-dropdown li[name=\"download-file-button\"] .fv__ui-button-icon:before {\n  background-image: url(../src/assets/icons/download.svg);\n}\n\na[name=\"dropdown-zoom\"]\n  .fv__ui-dropdown-toggler\n  .fv__icon-toolbar-zoom-out:before {\n  background-image: url(../src/assets/icons/out.svg);\n  left: 5px !important;\n}\n\na[name=\"dropdown-zoom\"]\n  .fv__ui-dropdown-toggler\n  .fv__icon-toolbar-zoom-in:before {\n  background-image: url(../src/assets/icons/in.svg);\n  left: 2px !important;\n}\n.fv__ui-contextmenu .fv__ui-dropdown {\n  padding: 0.2rem 1.4rem;\n  color: #444;\n}\n.fv__ui-contextmenu .fv__ui-dropdown .fv__ui-dropdown-item-text {\n  margin-left: 0 !important;\n}\n.fv__ui-button-text {\n}\n\na[name=\"freetext-textbox\"] a.fv__ui-dropdown-toggler:before,\na.image-dropdown a.fv__ui-dropdown-toggler:before,\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"]:before,\n.fx-ribbon-item[name=\"image-tool\"]:before,\nbutton[name=\"create-link\"] i.fv__ui-button-icon:before,\n.fx-ribbon-item[name=\"edit-text\"] .fx-ribbon-item-icon:before,\n.fx-ribbon-item[name=\"find-replace\"] .fx-ribbon-item-icon:before,\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler:before,\na[name=\"create-shape-dropdown\"] a.fv__ui-dropdown-toggler:before,\na[name=\"dropdown-zoom\"]\n  .fv__ui-dropdown-toggler\n  .fv__icon-toolbar-zoom-out:before,\nbutton[name=\"download-file-button\"] .fv__icon-toolbar-download:before,\na.more-dropdown > .fv__ui-dropdown-toggler:before,\nli[text=\"Merge File\"] .fv__ui-button-text:before,\nli[text=\"Convert File\"] .fv__ui-button-text:before,\n/* .edit-object-ribbon-dropdown:before, */\n.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list > li:before {\n  position: absolute;\n  content: \"\";\n  background-position: 100% 100%;\n  background-repeat: no-repeat;\n  width: 25px;\n  height: 25px;\n  left: 15px;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n\n/* Before element */\n\nli[text=\"Merge File\"] .fv__ui-button-text:before {\n  background-image: url(../src/assets/icons/merge.svg);\n  left: 0;\n}\nli[text=\"Convert File\"] .fv__ui-button-text:before {\n  background-image: url(../src/assets/icons/convert.svg);\n  left: 0;\n}\n\na.more-dropdown > .fv__ui-dropdown-toggler:before {\n  background-image: url(../src/assets/icons/dots.svg);\n  width: 20px;\n  height: 30px;\n  z-index: 4;\n  pointer-events: none;\n}\n\nbutton[name=\"download-file-button\"] .fv__icon-toolbar-download:before {\n  background-image: url(../src/assets/icons/save.svg);\n  left: 9px;\n}\n\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-icon:before {\n  background-image: url(../src/assets/icons/secure.svg);\n  margin-right: 5px;\n  z-index: 4;\n}\n\na.more-dropdown li.open-file .fv__ui-button-text,\na.more-dropdown li[name=\"download-file-button\"] .fv__ui-button-text,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler-text,\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-toggler-text,\nbutton[name=\"download-file-button\"] .fv__ui-button-text,\na.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text,\nli[text=\"Merge File\"] .fv__ui-button-text,\nli[text=\"Convert File\"] .fv__ui-button-text {\n  color: #2e2e2e !important;\n  font-size: 18px !important;\n  display: block !important;\n  text-transform: capitalize;\n  margin-left: 0 !important;\n  text-transform: capitalize;\n}\n/* a[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler-text {\n  margin-left: 20px !important;\n} */\n\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-toggler-text,\nbutton[name=\"download-file-button\"] .fv__ui-button-text,\na.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {\n  text-align: center !important;\n  width: 100% !important;\n}\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-toggler-text {\n  margin-right: 15px !important;\n  z-index: 4;\n  pointer-events: none;\n}\nli[text=\"Merge File\"] .fv__ui-button-text,\nli[text=\"Convert File\"] .fv__ui-button-text {\n  text-align: left !important;\n  width: 100% !important;\n  padding-left: 35px !important;\n}\na.more-dropdown li.open-file .fv__ui-button-text,\na.more-dropdown li[name=\"download-file-button\"] .fv__ui-button-text,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler-text {\n  text-align: left !important;\n  flex: 0 0 auto !important;\n}\n\na.fv__ui-sign-dropdown .fv__ui-dropdown-toggler:before {\n  background-image: url(../src/assets/icons/sign.svg);\n  margin-top: -2px;\n}\n\na[name=\"create-shape-dropdown\"] a.fv__ui-dropdown-toggler:before {\n  background-image: url(../src/assets/icons/shapes.svg);\n  left: 6px;\n  pointer-events: none;\n}\n\na.image-dropdown a.fv__ui-dropdown-toggler:before {\n  background-image: url(../src/assets/icons/gallery.svg);\n  z-index: 4;\n  pointer-events: none;\n}\n\na[name=\"freetext-textbox\"] a.fv__ui-dropdown-toggler:before {\n  background-image: url(../src/assets/icons/stickynote.svg);\n  left: 5px;\n  pointer-events: none;\n}\n\n.fx-icon-ribbon_edit_add_images-32 {\n  background-image: url(../src/assets/icons/gallery.svg) !important;\n  height: 25px !important;\n  width: 25px !important;\n  margin: 0 7px !important;\n}\n\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"]:before {\n  background-image: url(../src/assets/icons/ion_shapes-outline.svg);\n}\n.fx-ribbon-item[name=\"image-tool\"]:before,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(3):before {\n  background-image: url(../src/assets/icons/gallery.svg);\n}\ndiv[name=\"edit-object-ribbon-dropdown\"] .fv__icon-menu-edit,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(1):before {\n  width: 20px;\n  height: 20px;\n  background-image: url(../src/assets/icons/Edit.svg);\n}\nbutton[name=\"create-link\"] i.fv__ui-button-icon {\n  background-image: none !important;\n}\n\nbutton[name=\"create-link\"] i.fv__ui-button-icon:before {\n  background-image: url(../src/assets/icons/Link-icon.svg);\n  left: 10px;\n}\n.fx-ribbon-item[name=\"edit-text\"] .fx-ribbon-item-icon:before,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(2):before {\n  background-image: url(../src/assets/icons/Text-icon.svg);\n}\n.fv__icon-menu-add-text {\n  background-image: url(../src/assets/icons/Text-icon.svg) !important;\n  width: 25px !important;\n  height: 25px !important;\n  margin: 0 7px !important;\n}\n.fx-ribbon-item[name=\"find-replace\"] .fx-ribbon-item-icon:before {\n  background-image: url(../src/assets/icons/search.svg);\n  background-size: cover;\n}\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(4):before {\n  background-image: url(../src/assets/icons/shapes.svg);\n}\n/* After element */\na[name=\"freetext-textbox\"]:after,\na[name=\"create-shape-dropdown\"]:after,\na.image-dropdown:after,\n.fx-ribbon-item[name=\"edit-text\"]:after,\n.fx-ribbon-item[name=\"find-replace\"]:after,\nbutton[name=\"create-link\"]:after,\n.fx-ribbon-item[name=\"image-tool\"]:after,\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"]:after,\nbutton.open-file:after,\na.fv__ui-sign-dropdown:after,\na[name=\"dropdown-zoom\"]:after,\n.fx-ribbon-item[name=\"edit-object-ribbon-dropdown\"]:after {\n  position: absolute;\n  color: #2e2e2e;\n  font-size: 18px;\n  right: 20px;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n.fx-ribbon-item[name=\"edit-object-ribbon-dropdown\"]:after {\n  right: 36px;\n}\na.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {\n  padding-left: 15px;\n  z-index: 4;\n  pointer-events: none;\n}\n\na.more-dropdown > .fv__ui-dropdown-list {\n  padding: 0 !important;\n  min-width: 220px !important;\n}\n.edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list {\n  @apply !top-[25px] !p-0 !right-0;\n  min-width: 185px !important;\n}\na.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button,\na[name=\"freetext-textbox\"] {\n  width: 100% !important;\n  height: auto !important;\n  display: block !important;\n  position: static !important;\n  width: 100% !important;\n}\na[name=\"freetext-textbox\"],\na[name=\"create-shape-dropdown\"] {\n  height: 56px !important;\n}\na.more-dropdown .fv__ui-dropdown-list > li.fv__ui-dropdown-button {\n  padding: 14px 7px !important;\n}\na[name=\"password-protect-controllers\"] ul.fv__ui-dropdown-list .fv__ui-button {\n  @apply !py-0 !px-2 !rounded-lg;\n}\na[name=\"freetext-textbox\"] {\n  position: relative !important;\n}\na.more-dropdown li[name=\"download-file-button\"] .fv__ui-button-icon {\n  background: none;\n}\n\nbutton.open-file:after {\n  content: \"Open File\";\n  right: 15px;\n}\n\nbutton.new-file:after {\n  content: \"New File\";\n  right: 15px;\n}\n\na[name=\"create-shape-dropdown\"]:after {\n  content: \"Shapes\";\n  right: auto;\n  left: 40px;\n  pointer-events: none;\n}\na.fv__ui-sign-dropdown:after {\n  content: \"Sign\";\n  right: 38px;\n  pointer-events: none;\n}\na.image-dropdown:after {\n  content: \"Image\";\n  right: 40px;\n  z-index: 4;\n  pointer-events: none;\n}\na[name=\"freetext-textbox\"]:after {\n  content: \"Forms\";\n  right: auto;\n  left: 40px;\n  pointer-events: none;\n}\n\n.fx-ribbon-item[name=\"edit-text\"]:after {\n  content: \"Edit Text\";\n}\n.fx-ribbon-item[name=\"edit-object-ribbon-dropdown\"]:after {\n  content: \"Content\";\n}\n.fx-ribbon-item[name=\"find-replace\"]:after {\n  content: \"Search \\A & Replace\";\n  white-space: pre; /* or pre-wrap */\n  line-height: 1.2;\n}\nbutton[name=\"create-link\"]:after {\n  content: \"Link\";\n}\n.fx-ribbon-item[name=\"image-tool\"]:after {\n  content: \"Image\";\n  right: 10px;\n}\n.fx-ribbon-item[name=\"create-shapeObject-dropdown\"]:after {\n  content: \"Shapes\";\n  right: 0;\n}\na[name=\"create-shape-dropdown\"] .fv__ui-dropdown-list,\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-list {\n  @apply h-52 overflow-auto !right-0;\n}\na[name=\"dropdown-zoom\"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {\n  @apply !py-0 !rounded-lg;\n}\na[name=\"create-shape-dropdown\"]\n  .fv__ui-dropdown-list\n  > li.fv__ui-dropdown-button {\n  @apply !py-[4px] !rounded-lg;\n}\na[name=\"password-protect-controllers\"] .fv__ui-dropdown-list {\n  @apply !right-0;\n}\n.fv__ui-mobile .fv__ui-layer-header-inner {\n  padding: 0.6875rem 0 !important;\n}\n.fv__ui-addon-font-size-dropdown .fv__ui-dropdown-list,\n.fv__ui-addon-font-family-dropdown .fv__ui-dropdown-list {\n  @apply !right-0;\n}\n@media (max-width: 991px) {\n  a[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler-text {\n    margin-left: 15px !important;\n  }\n  a[name=\"dropdown-zoom\"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {\n    line-height: 1.3 !important;\n    padding: 5px 7px !important;\n  }\n  a[name=\"password-protect-controllers\"] .fv__ui-dropdown-toggler-text,\n  li[text=\"Convert File\"] .fv__ui-button-text,\n  a[name=\"create-shape-dropdown\"]:after,\n  a[name=\"freetext-textbox\"]:after,\n  li[text=\"Merge File\"] .fv__ui-button-text,\n  a[name=\"dropdown-zoom\"] .fv__ui-dropdown-toggler-text {\n    font-size: 16px !important;\n  }\n  a.more-dropdown > .fv__ui-dropdown-list {\n    min-width: 200px;\n  }\n  button[name=\"create-link\"] i.fv__ui-button-icon {\n    width: 100%;\n  }\n  a.more-dropdown .fv__ui-dropdown-list .fv__ui-dropdown-toggler {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  a.image-dropdown:after,\n  .fx-ribbon-item[name=\"edit-text\"]:after,\n  .fx-ribbon-item[name=\"find-replace\"]:after,\n  button[name=\"create-link\"]:after,\n  .fx-ribbon-item[name=\"image-tool\"]:after,\n  .fx-ribbon-item[name=\"create-shapeObject-dropdown\"]:after,\n  button.open-file:after,\n  a.fv__ui-sign-dropdown:after,\n  a[name=\"dropdown-zoom\"]:after,\n  button[name=\"download-file-button\"] .fv__ui-button-text,\n  a.more-dropdown > .fv__ui-dropdown-toggler > .fv__ui-dropdown-toggler-text {\n    display: none !important;\n  }\n  button[name=\"download-file-button\"],\n  a[name=\"create-shape-dropdown\"],\n  a.image-dropdown,\n  a.fv__ui-sign-dropdown,\n  a[name=\"freetext-textbox\"],\n  a[name=\"password-protect-controllers\"],\n  a[name=\"dropdown-zoom\"],\n  a[name=\"freetext-textbox\"],\n  .fx-ribbon-item[name=\"image-tool\"],\n  .fx-ribbon-item[name=\"create-shapeObject-dropdown\"],\n  a.more-dropdown {\n    min-width: 75px !important;\n  }\n\n  button[name=\"create-link\"],\n  .fx-ribbon-item[name=\"edit-text\"],\n  .fx-ribbon-item[name=\"find-replace\"],\n  button[name=\"hand-tool\"],\n  button.open-file {\n    width: 50px !important;\n    min-width: 55px !important;\n  }\n\n  .pdfMenu > :nth-child(n) {\n    height: 50px !important;\n    border-bottom: 1px solid #ececec;\n  }\n\n  a[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list .fx-ribbon-item {\n    margin: 0 10px !important;\n  }\n  a[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list {\n    padding-left: 3px;\n    padding-right: 3px;\n  }\n  button[name=\"download-file-button\"] .fv__icon-toolbar-download:before,\n  button[name=\"create-link\"] i.fv__ui-button-icon:before {\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  button.open-file:before {\n    margin: 0 auto;\n  }\n  .fx-ribbon-item[name=\"edit-text\"],\n  button[name=\"create-link\"],\n  .fx-ribbon-item[name=\"image-tool\"],\n  .fx-ribbon-item[name=\"create-shapeObject-dropdown\"],\n  .pdfMenu > :nth-child(n) {\n    @apply !w-[60px];\n  }\n  .more-dropdown .fv__ui-dropdown-list {\n    @apply !right-[130px];\n  }\n  a[name=\"dropdown-zoom\"] .fv__ui-dropdown-list > li.fv__ui-dropdown-button {\n    @apply !py-1;\n  }\n  a[name=\"freetext-textbox\"] ul.fv__ui-dropdown-list {\n    @apply !right-1 w-[250px];\n  }\n}\n.fv__ui-sign-dropdown-list {\n  @apply !w-[180px];\n}\n.fv__ui-sign-dropdown-list .fv__ui-sign-list {\n  @apply !mb-0;\n}\n.fx-ribbon-item {\n  @apply flex items-center !important;\n}\n.fx-ribbon-item-text {\n  @apply flex items-center space-x-1 pr-1.5;\n  color: #2e2e2e;\n  font-size: 18px !important;\n}\n.touchup_handler_container {\n  z-index: 10 !important;\n}\n\na.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:after {\n  display: none !important;\n}\na[name=\"signature-dropdown\"]\n  ul.fv__ui-dropdown-list\n  li.fv__ui-dropdown-button:before,\na.image-dropdown ul.fv__ui-dropdown-list li.fv__ui-dropdown-button:before {\n  width: 140px !important;\n  font-size: 14px;\n  height: 48px;\n}\n\n.fv__ui-dropdown-button i {\n  @apply hidden !important;\n}\n.fv__ui-dropdown-list > li.fv__ui-dropdown-button {\n  min-width: 150px !important;\n}\n.t_1 .fv__ui-button {\n  width: 1.5rem !important;\n}\n.jc_sb .fv__ui-button {\n  width: 100% !important;\n}\n.d_f {\n  @apply items-center;\n}\n#ribbon-text_unique_liodsvnh_8 {\n}\n\ndiv[name=\"fv--plugin-PageEditor-add-image\"] .fx-ribbon-item-text:after {\n  content: \"Add Image\" !important;\n  white-space: pre;\n  line-height: 1.2;\n}\ndiv[name=\"fv--plugin-PageEditor-add-image\"]\n  .fx-ribbon-item-text\n  .fx-ribbon-item-text-1 {\n  @apply hidden;\n}\ndiv[name=\"fv--plugin-PageEditor-add-image\"]\n  .fx-ribbon-item-text\n  .fx-ribbon-item-text-2 {\n  @apply hidden;\n}\ndiv[name=\"fv--plugin-PageEditor-add-text\"] .fx-ribbon-item-text,\ndiv[name=\"fv--plugin-PageEditor-add-image\"] .fx-ribbon-item-text {\n  @apply pt-1;\n}\n\n/* .edit-object-ribbon-dropdown .fx-ribbon-item-icon, */\n.edit-object-ribbon-dropdown .fx-ribbon-item-more,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:last-child,\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li:nth-child(2) {\n  @apply hidden;\n}\n.edit-object-ribbon-dropdown\n  a.fv__ui-dropdown\n  > .fv__ui-dropdown-list\n  > li\n  .fv__ui-dropdown-item-text {\n  color: #2e2e2e;\n  margin-left: 2.5rem;\n  font-size: 18px !important;\n}\ndiv[name=\"edit-object-ribbon-dropdown\"] .fx-ribbon-item-icon {\n  @apply mb-1 ml-3;\n}\n.pdfMenu.fv__ui-toolbar {\n  @apply !overflow-visible;\n}\n.fv__ui-dropdown-list {\n  @apply !relative !top-0 !left-auto right-[60px];\n}\n@media (max-width: 768px) {\n  .fv__ui-directive-lazy-content {\n    @apply absolute bottom-0 z-[100] w-full h-[30rem] !important;\n  }\n\n  .fv__ui-directive-lazy-content .body {\n    @apply bg-white;\n  }\n  .edit-object-ribbon-dropdown a.fv__ui-dropdown > .fv__ui-dropdown-list {\n    @apply !top-[1.6rem];\n  }\n  .fv__ui-mobile .fv__pdf-view-mode-item {\n    @apply !m-2;\n  }\n  .fv__ui-directive-draggable {\n    @apply w-[38rem] mx-auto bg-white;\n  }\n  div[name=\"create-signature\"] .fv__ui-layer-header {\n    padding: 10px 15px;\n    margin: -23px -12px 0;\n  }\n  .fv__ui-layer .footer .fv__ui-dialog-ok-button,\n  .fv__ui-layer .footer .fv__ui-dialog-cancel-button,\n  .fv__password-protect-popup\n    .document-permission-wrapper-inner\n    .permission-edit-btn,\n  .fv__ui-sign-dialog-tab-panel\n    .fv__ui-sign-dialog-panel[name=\"sign-dialog-panel-type\"]\n    .type-body\n    .customInput\n    .addList {\n    min-height: 46px !important;\n    border-radius: 8px !important;\n  }\n  .fv__ui-mobile .fv__ui-sign-layer {\n    min-width: 93% !important;\n  }\n  .fv__ui-mobile .fv__ui-layer {\n    max-width: 93% !important;\n  }\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col {\n    @apply flex-col gap-3;\n  }\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col\n    .fv__appearance-dialog-col-item {\n    @apply !w-full flex;\n  }\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col\n    .fv__appearance-dialog-col-item\n    .fv__appearance-dialog-label {\n    @apply !flex items-center;\n  }\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col\n    .fv__appearance-dialog-col-item\n    .fv__ui-select,\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col\n    .fv__appearance-dialog-col-item\n    input,\n  .fv__ui-annot-actions-dialog\n    .fv__ui-layer-inner\n    .fv__link-dialog-container\n    .fv__appearance-dialog-container\n    .fv__appearance-dialog-body\n    .fv__appearance-dialog-col\n    .fv__appearance-dialog-col-item\n    select {\n    @apply !w-[180px];\n  }\n}\n@media (max-width: 400px) {\n  .fv__ui-mobile .fv__ui-sign-dialog-footer {\n    @apply !items-start !flex-col !gap-6;\n  }\n  .fv__ui-mobile .fv__ui-sign-dialog-btns {\n    @apply !ml-0;\n  }\n  .fv__ui-sign-dialog-tab-panel\n    .fv__ui-sign-dialog-panel[name=\"sign-dialog-panel-type\"]\n    .type-body\n    .customInput\n    .addList {\n    min-width: 5.75rem !important;\n  }\n}\n\n.fv__ui-button-icon,\n.fv__icon-toolbar-hand {\n  font-size: 22px !important;\n  font-weight: 600 !important;\n}\n\n\n\n.fv__annot-container-zindex-up .fv__pdf-page-handler-container{\n  z-index: 10 !important;\n}\n\n\n.grecaptcha-badge {\n  @apply bottom-4 md:bottom-20 !important;\n}\n\n.pdfMenu:before,\n.pdfMenu:after{\n  background-color: none !important;\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
